// Copyright (C) 2012 Minted Inc.
// All Rights Reserved

/**
 * Object for storing Google Analytics constants
 */
/*
  UMD header generated via modularize.js at 2015-04-02T22:08:28.206Z
*/
var module; UMD(module, {
  'minted:m': ['M'],
})(this, function (m_module) {
"use strict";
var M = m_module.M;

M.GA = M.GA || {};

/**
 * Namespace for constants related to die cut shapes
 * https://wiki.minted.com/index.php/Die_Cut_Shapes
 */
M.DIECUT = M.DIECUT || {};

/**
* Object for storing cookie related constants
*/
M.COOKIE = M.COOKIE || {};

/**
* Object for storing extension related constants
*/
M.EXTENSION = M.EXTENSION || {};

/**
* Object for storing constants related to checkout related constants
*/
M.CHECKOUT = M.CHECKOUT || {};

/**
* Object for storing constants related shipping options extra info
*/
M.SHIPPING = M.SHIPPING || {};
/**
* Object for storing constants related to rendering designer signatures
* or the designer signature internal tool.
*/
M.DESIGNER_SIGNATURE = M.DESIGNER_SIGNATURE || {};

/**
 * Adds a 200ms delay when tracking GA events that cause the page to redirect.
 * For example, We want to track a button click as a GA Event, but the
 * button causes the page to redirect. Solution: add a small delay to ensure
 * that the GA tracking pixel is requested before the page reloads.
 */
M.GA.EVENT_TRACKING_REDIRECT_DELAY = 200;

/**
 * Object for storing scene 7 related constants.
 */
M.Scene7 = M.Scene7 || {};

M.Scene7.RENDER_TYPE = {
  LOAD: 'scene7_load',
  TEXT: 'scene7_text',
  IMAGE: 'scene7_image',
  PHOTO: 'scene7_photo',
  UNKNOWN: 'scene7_unknown'
};

/* Cloudinary */
var CLOUDINARY_URL = "https://assets.minted.com/image/fetch/";

/* FXG Color */
var RGB_HEX_STRING_LENGTH = 7; // RGB is 6 digits + "#" (total 7)

/**
 * Values of "utm_campaign" passed to Google Analytics
 */
M.GA.SHARE_CAMPAIGN = {
  DEFAULT_CAMPAIGN: 'shared_link',
  ART_LANDING: 'art_landing',
  BOARDS: 'boards',
  CATEGORY: 'category',
  DESIGNS: 'designs',
  PDP: 'product_details_share',
  STOREFRONT: 'storefront',
  PHOTOGRAPHER: 'photographer'
};

/**
 * Values of "utm_medium" passed to Google Analytics
 */
M.GA.SHARE_MEDIUM = {
  DEFAULT_MEDIUM: 'default',
  ADDED_TO_BOARD_MY_BOARDS: 'addedToBoard_myBoards',
  ADDED_TO_BOARD_BOARD_DETAIL: 'addedToBoard_boardDetail',
  ADDED_TO_BOARD_VOTE: 'addedToBoard_vote',
  ADDED_TO_BOARD_PREVIEW: 'addedToBoard_preview',
  ADDED_TO_BOARD_DESIGN_RATING: 'addedToBoard_designRating',
  BOARD_WIDGET: 'board_widget',
  DESIGNER_CATEGORY: 'designer_category',
  DESIGN_VOTE: 'design_vote',
  DROPDOWN_ALL_BOARDS: 'dropdown_allBoards',
  DROPDOWN_MY_BOARDS: 'dropdown_myBoards',
  DROPDOWN_BOARD_DETAIL: 'dropdown_boardDetail',
  DROPDOWN_BOARD_DETAIL_QUICKLOOK: 'dropdown_quicklook',
  DROPDOWN_VOTE: 'dropdown_vote',
  DROPDOWN_PREVIEW: 'dropdown_preview',
  DROPDOWN_DESIGN_RATING: 'dropdown_designRating',
  PDP_SHARE_THIS_DESIGN: 'pdp_shareThisDesign',
  PDP_SOCIAL_ICONS: 'social',
  PHOTOGRAPHER_PROMOTE: 'photographer_promote',
  STOREFRONT_HOME: 'storefront_home'
};

/**
 * Values of "utm_source" passed to Google Analytics
 */
M.GA.SHARE_SOURCE = {
  FACEBOOK: 'facebook',
  PINTEREST: 'pinterest',
  GOOGLE_PLUS: 'google_plus',
  TWITTER: 'twitter'
};

/**
 * Prefix for "network" parameter in "_trackSocial" call to Google Analytics
 * that is made when social icons are clicked
 */
M.GA.TRACK_SOCIAL_NETWORK_PREFIX = {
  ART: 'art_',
  BOARDS: 'boards_',
  CATEGORY: 'category_',
  CHALLENGE: 'challenge_',
  DESIGN_VOTE: 'design_vote_',
  PDP: 'PDP_',
  PHOTOGRAPHER: 'photographer_'
};

/**
 * Values used for reporting on social icon clicks
 * Keep in sync with minted/model/social_action.py
 */
M.GA.TRACK_SOCIAL_PAGE_TYPE = {
  BOARD_DETAIL: 1,
  BOARD_EXPLORE: 2,
  BOARD_QUICK_LOOK: 3,
  BOARD_MYBOARDS: 4,
  DESIGN_VOTE: 5,
  DESIGN_RATING: 6,
  DESIGN_CHALLENGE: 7,
  STOREFRONT: 8,
  PRODUCT_DETAILS: 9,
  BOARD_ADDED_TO_BOARD: 10,
  DESIGNER_CATEGORY: 11,
  PHOTOGRAPHER: 12,
  BOARD_WIDGET: 13,
  ART_WALL: 14,
  CATEGORY_PAGE: 15
};

/**
 * Values used for reporting on social icon clicks
 * Keep in sync with minted/model/social_action.py
 */
M.GA.TRACK_SOCIAL_ACTION_TYPE = {
  PINTEREST: 1,
  FACEBOOK: 2,
  GOOGLE_PLUS: 3,
  EMBED: 4,
  TWITTER: 5
};

/**
 * Values of "category" parameter in "_trackEvent" call to Google Analytics
 */
M.GA.TRACK_EVENT_CATEGORY = {
  ADD_TO_CART_DIALOG: 'add_to_cart_dialog',
  ADDRESSING: 'Addressing',
  ADDRESSING_SHOWN: 'addressing_shown',
  ACCOUNT: 'Account',
  BOARDS: 'Pinboards',
  BNPL: 'buy_now_personalize_later',
  BROWSE: 'Browse', //aka Category page
  CART: 'cart',
  CHANGE_ATTRIBUTES: 'change_attributes_dialog',
  CHECKOUT: 'checkout',
  COMMUNITY: 'community',
  COMMUNITY_ARTIST_DASHBOARD: 'community_artist_dashboard',
  COMMUNITY_CHALLENGE_SUBMIT: 'community_challenge_submit',
  COMMUNITY_CONTEST: 'community_contest',
  COMMUNITY_CONTEST_SUMMARY: 'community_contest_summary',
  COMMUNITY_DESIGNER: 'community_designer',
  COMMUNITY_DESIGN_RATING: 'community_design_rating',
  COMMUNITY_DESIGN_VOTE: 'community_design_vote',
  COMMUNITY_PARTICIPATE_OVERVIEW: 'community_participate_overview',
  COMMUNITY_FACEBOOK_CONNECT: 'community_facebook_connect',
  COMMUNITY_WINNERS: 'community_winners',
  COMMUNITY_VOTING_GALLERY: 'community_voting_gallery',
  CU3: 'CU3',
  CURATOR_STORE: 'curator_store',
  EMAIL_LIGHTBOX: 'email_lightbox',
  FIF: 'find_it_fast',

  // The older GA category for tracking browse events. This was left in because
  // Faceted Product Search: nav.browse, nav.free text, and nav.empty category
  // are still used in the weekly conversion report for funnel tracking.
  // TODO: Remove and replace with "Browse"
  FACETED_PRODUCT_SEARCH: 'Faceted Product Search',

  HOME: 'homepage',
  HELP: 'helppage',
  FORGOT: 'forgot',
  KEEPSAKE: 'keepsake',
  LEADERBOARD: 'leaderboard',
  LOGIN: 'login',
  MISSING_CONTENT: 'cu3_missing_content',
  NOTIFICATION: 'notification',
  ORDERS: 'orders',
  ORDER_CONFIRM: 'order_confirm',
  ORDERS_SHOWN: 'orders_shown',
  ORDER_DETAIL: 'order_detail',
  ORDER_DETAIL_SHOWN: 'order_detail_shown',
  PAP: 'PAP',
  PDP: 'PDP',
  PDP_ART: 'PDP_ART',
  POST_ORDER_CU3: 'post_order_cu3',
  PHOTO_TRAY: 'photo_tray',
  PRODUCT_ADMIN: 'product_admin',
  REGISTER: 'register',
  MY_PROJECTS: 'my_projects',
  REVIEW_ORDER: 'review_order',
  SAMPLE_MODAL: 'sample_modal',
  SCENE7: 'scene7',
  STORES_CONSUMER_UI: 'stores_consumer_ui',
  STORES_MERCH_TOOLS: 'stores_merch_tools',
  WEBFORM: 'webform',
  WEBFORM_CLICK: 'web_form_click'
};

/**
 * Values of "action" parameter in "_trackEvent" call to Google Analytics
 * Please avoid adding new actions. Use a general action and a EVENT_CATEGORY
 * to add specificity
 */
M.GA.TRACK_EVENT_ACTION = {
  ABOUT_ARTIST_ARTIST_CLICK: 'about_artist_artist_click',
  ABOUT_BINDINGS_CLICK: 'about_bindings_click',
  ABOUT_FABRICS_CLICK: 'about_fabrics_click',
  ABOUT_FORMATS_CLICK: 'about_formats_click',
  ABOUT_PAPERS_CLICK: 'about_papers_click',
  ABOUT_THE_ARTIST_CLICK: 'about_the_artist_click',
  ACTIVATE: "activate",
  ADD_DESIGNER_TO_FAVORITES: 'add_designer_to_favorites',
  ADD_RCP_CLICK: 'add_rcp_click',
  ADD_BACKER_CLICK: 'add_backer_click',
  ADD_TO_BOARD_CLICK: 'add_to_board_click',
  ADD_TO_BOARD_ICON_CLICK: 'add_to_board_icon_click',
  ADD_TO_ORDER_CLICK: 'add_to_order_click',
  ADDON_CHANGE_CLICK: 'addon_change_click',
  ADDON_CHANGE_SHOWN: 'addon_change_shown',
  ADDRESSING_ADD: 'Add addresses',
  ADDRESSING_UPLOAD: 'Upload Addresses',
  ADDRESSING_RAP_OPTION_CLICK: 'addressing_rap_option_click',
  ADDRESSING_RCP_OPTION_CLICK: 'addressing_rcp_option_click',
  ART_PAPER_CLICK: 'art_paper_click',
  ART_SIGNATURE_CHECKED: 'art_signature_checked',
  ART_SIGNATURE_UNCHECKED: 'art_signature_unchecked',
  ART_SHOW_FRAMED_CLICK: 'art_show_framed_click',
  ARTIST_NAME_CLICK: 'artist_name_click',
  ARTIST_PAGE_VISIT: 'artist_page_visit',
  ARTICLE_CLICK: 'featured_articles_click',
  AUTHENTICATION_MORE_LINK_CLICK: 'authentication_more_link_click',
  AUTO_DETECT: 'auto_detect',
  AVAILABLE_IN_OTHER_DESIGNS_CLICK: 'available_in_other_designs_click',
  SEARCH_BOX: 'search_box',
  BACK_TO_ORDERS_CLICK: 'back_to_orders_click',
  BACK_TO_TOP_CLICK: 'back_to_top_click',
  BADGE_CLICK: 'badge_click',
  BANNER_CLICK: 'banner_click',
  BACKER_LOGO_OPT_IN: 'backer-logo-opt-in',
  BACKER_LOGO_VIEW_DIALOG: 'backer-logo-view-dialog',
  BOARD_TYPE_SELECTED: 'board_type_selected',
  BODY_ACTIVATE: 'body_activate',
  BOTTOM_MODULE_MORE_BY_ARTIST_SKU_CLICK: 'bottom_module_more_by_artist_sku_click',
  BOTTOM_MODULE_SHOP_MORE_BY_ARTIST: 'bottom_module_shop_more_by_artist',
  BOTTOM_MODULE_SWITCH_TAB: 'bottom_module_switch_tab',
  BREADCRUMB_1_CLICK: 'breadcrumb_1_click',
  BREADCRUMB_2_CLICK: 'breadcrumb_2_click',
  BROWSE_CAT_PAGE: 'nav.browse category',
  BNPL_FINISH_LINK_CLICK: 'bnpl_finish_link_click',
  BNPL_PRE_ORDER_ACTIONS: 'buy_now_personalize_later_pre_order_actions',
  CANCEL: 'cancel',
  CANCEL_CHANGES: 'cancel_changes',
  CANCEL_CLICK: 'cancel_click',
  CANCEL_DIALOG: 'cancel_dialog',
  CANCEL_ITEM_CLICK: 'cancel_item_click',
  CANCEL_ITEM_SHOWN: 'cancel_item_shown',
  CANCEL_ITEM_DIALOG: 'cancel_item_dialog',
  CANCEL_ORDER_CLICK: 'cancel_order_click',
  CANCEL_ORDER_SHOWN: 'cancel_order_shown',
  CAROUSEL_NEXT_CLICK: 'carousel_next_click',
  CAROUSEL_PREVIOUS_CLICK: 'carousel_previous_click',
  CART_PAGE_LOAD: 'cart_page_load',
  CART_LINE_ITEM_LOAD:'cart_line_item_load',
  CART_ADD_RECIPIENT_ADDRESS_CLICKED: 'add_recipient_address_clicked',
  CART_EDIT_SAVED_DESIGN: 'cart_edit_saved_design',
  CART_PROMO_CODE_REMOVE: 'cart_promo_code_remove',
  CART_PROMO_DISCOUNT_CREDIT_TOGGLE: 'cart_promo_discount_credit_toggle',
  CART_BUY_CREDIT_DIALOG: 'cart_buy_credit_dialog',
  CART_BUY_CREDIT_SUCCESS: 'cart_buy_credit_success',
  CART_BUY_CREDIT_FAILURE: 'cart_buy_credit_failure',
  CASE_CREATE_FAILURE: 'case_create_failure',
  CASE_CREATE_SUCCESS: 'case_create_success',
  CATEGORY_LINK_CLICK: 'category_link_click',
  CAROUSEL_CLICK: 'carousel_click',
  CHALLENGE_SUBMISSION_ERROR: 'challenge_submission_error',
  CHANGE_BACKER: 'change_backer',
  CHANGE_COLOR: 'change_color',
  CHANGE_BINDING: 'change_binding',
  CHANGE_DESIGN_OPTIONS_CLICK: 'change_design_options_click',
  CHANGE_ENVELOPE: 'change_envelope',
  CHANGE_FORMAT: 'change_format',
  CHANGE_FRAME: 'change_frame',
  CHANGE_LABEL: 'change_label',
  CHANGE_LINER: 'change_liner',
  CHANGE_PAPER: 'change_paper',
  CHANGE_QUANTITY: 'change_quantity',
  CHANGE_RAP: 'change_rap',
  CHANGE_RCP: 'change_rcp',
  CHANGE_SHAPE: 'change_shape',
  CHANGE_SPECIAL_REQUEST: 'change_special_request',
  CHANGE_STATUS: 'change status',
  CHECKBOX_CLICK: 'checkbox_click',
  CHECKOUT_PAGE_LOAD: 'checkout_page_load',
  CHECKOUT_LINE_ITEM_LOAD: 'checkout_line_item_load',
  CHOOSE_BOARD_TYPE_CLICK: 'choose_board_type_click',
  CLOSE: 'close',
  COLOR_ELEMENT_CHOICE_CLICK: 'color_palette_click',
  COLOR_SWATCH_CLICK: 'color_swatch_click',
  COLOR_SWATCH_HOVER: 'color_swatch_hover',
  CONTACT_REASON: 'contact_reason',
  CONTACT_US_CLICK: 'contact_us_click',
  CONTEST_CALENDAR_DOWNLOAD: 'contest_calendar_download',
  CHOOSE_FILE_BUTTON_CLICK: 'choose_file_button_click',
  COMMUNITY_TAB_CLICK: 'community_tab_click',
  COMMENT_ON_DESIGN: 'comment_on_design',
  COMMENT_DESIGNER_NAME_CLICK: 'comment_designer_name_click',
  COMMENT_SUBMIT_BUTTON_CLICK: 'comment_submit_button_click',
  CURATE_LINK_CLICK: 'curate_link_click',
  DASHBOARD_PANEL_HEADER_CLICK: 'dashboard_panel_header_click',
  DELETE_LINE_ITEM_CLICK: 'delete_line_item_click',
  DELIVERY_OPTIONS_CLICK: 'delivery_options_click',
  DESIGN_LIKED: 'design_liked',
  DESIGN_UNLIKED: 'design_unliked',
  DESIGN_IMAGE_CLICK: 'design_image_click',
  DESIGN_TITLE_CLICK: 'design_title_click',
  DESIGN_STOCK_ART_CHECKBOX_CLICK: 'design_stock_art_checkbox_click',
  DELETE_LINE_ITEM_DIALOG_CLICK: 'delete_line_item_dialog_click',
  DESIGN_LINK_CLICK: 'design_link_click ',
  DESIGNER_LINK_CLICK: 'designer_link_click',
  DESIGNER_WEBSITE_LINK_CLICK: 'designer_website_link_click',
  DIGITAL_PROOF_CLICK: 'digital_proof_click',
  DIMENSION_INFO_CLICK: 'dimension_info_click',
  DOWNLOAD_CHALLENGE_SUBMISSION_KIT: 'download_challenge_submission_kit',
  DOWNLOAD_PRINTABLE: 'download_printable',
  DOWNLOAD_WALLPAPER: 'download_wallpaper',
  EDIT_BACKER: 'edit_backer',
  EDIT_CUSTOM_FOIL: 'edit_custom_foil',
  EDIT_DESIGN_BUTTON_CLICK: 'edit_design_button_click',
  EDIT_DESIGN_BUTTON_SHOWN: 'edit_design_button_shown',
  EDIT_ENVELOPE: 'edit_envelope',
  EDIT_INFO_CLICK: 'edit_info_click',
  EDIT_LABEL: 'edit_label',
  EDIT_LINER: 'edit_liner',
  EDIT_RAP: 'edit_rap',
  EDIT_RCP: 'edit_rcp',
  EDIT_SHAPE: 'edit_shape',
  EDIT_SHIPPING_ADDRESS_CLICK: 'edit_shipping_address_click',
  EDIT_SHIPPING_ADDRESS_SHOWN: 'edit_shipping_address_shown',
  EDIT_SHIPPING_CONFIRM: 'edit_shipping_confirm',
  EDIT_SHIPPING_OPTION_CLICK: 'edit_shipping_option_click',
  EDIT_SHIPPING_OPTION_SHOWN: 'edit_shipping_option_shown',
  EDIT_TEXT: 'edit_text',
  EMAIL_INPUT_KEYDOWN: 'email_input_keydown',
  EMAIL_TO_A_FRIEND_CLICK: 'email_to_a_friend_click',
  EMAIL_US_CLICK: 'email_us_click',
  EMPTY_SEARCH_RESULTS: 'nav.empty search result',
  ENVELOPE_COLOR_SELECTED: 'envelope_color_selected',
  ENVELOPE_LINER_SELECTED: 'envelope_liner_selected',
  EVENT_CALENDAR_DOWNLOAD: 'event_calendar_download',
  FAQ_LINK_CLICK: 'faq_link_click',
  FANCY_RAP_OPTION_CLICKED: 'fancy_rap_option_clicked',
  FANCY_RCP_OPTION_CLICKED: 'fancy_rcp_option_clicked',
  FAVORITE_DESIGNER_PAGE_CLICK: 'favorite_designer_page_click',
  FAVORITES_TRAY_TRIGGERED: 'favorites_tray_triggered',
  FAVORITES_TRAY_PRODUCT_CLICK: 'favorites_tray_product_click',
  FILE_ATTACHMENT_START: 'file_attachment_start',
  FILE_ATTACHMENT_SUCCESS: 'file_attachment_success',
  FILE_ATTACHMENT_FAILURE: 'file_attachment_failure',
  FILTER_PANEL_TOGGLE_COLLAPSE: 'filter_panel_toggle_collapse',
  FILTER_TOGGLE_MORE_LESS: 'filter_toggle_more_less',
  FILTER_DESELECTED: 'filter_deselected',
  FILTER_SELECTED: 'filter_selected',
  FIND_IT_FAST_SHOW: 'find_it_fast_show',
  FIND_IT_FAST_TOGGLE: 'find_it_fast_toggle',
  FIND_IT_FAST_CHANGE_PHOTO: 'find_it_fast_change_photo',
  FIND_IT_FAST_INITIAL_DIALOG: 'find_it_fast_initial_dialog',
  FIND_IT_FAST_CHANGE_PHOTO_PROCESSING_DIALOG: 'find_it_fast_change_photo_processing_dialog',
  FIND_IT_FAST_CLOSE_WITHOUT_PHOTO: 'find_it_fast_close_without_photo',
  FIND_IT_FAST_CLICK_LABEL: 'find_it_fast_click_label',
  FIND_IT_FAST_OLD_CLICK_BUTTON: 'find_it_fast_old_click_button',
  FIND_IT_FAST_TOP_TRAY_SHOW: 'find_it_fast_top_tray_show',
  FIND_IT_FAST_TOP_TRAY_TOGGLE: 'find_it_fast_top_tray_toggle',
  FINISH_PERSONALIZING_CLICK: 'finish_personalizing_click',
  FOOTER_LINK_CLICK: 'footer_link_click',
  FRAME_OPTION_CLICK: 'frame_option_click',
  FRAME_OPTION_HOVER: 'frame_option_hover',
  FRAME_SIZE_CHANGE_CLICK: 'frame_size_change_click',
  FRAME_SIZE_SOLD_OUT_POPUP_SHOWN: 'frame_size_sold_out_popup_shown',
  FRAME_SIZE_SOLD_OUT_TOOLTIP_SHOWN: 'frame_size_sold_out_tooltip_shown',
  FRAME_SOLD_OUT_MESSAGE_CHANGE: 'frame_sold_out_message_change',
  FRAME_SOLD_OUT_MESSAGE_SHOWN: 'frame_sold_out_message_shown',
  FRAME_SOLD_OUT_POPUP_SHOWN: 'frame_sold_out_popup_shown',
  FRAME_SOLD_OUT_TOOLTIP_SHOWN: 'frame_sold_out_tooltip_shown',
  FRAME_DESCRIPTION_LESS_CLICK: 'frame_description_less_click',
  FRAME_DESCRIPTION_MORE_CLICK: 'frame_description_more_click',
  FRAMING_YOUR_PRINT_CLICK: 'frameing_your_print_click',
  FRCP_PROMO_CLOSED: 'Fancy_RCP_Promo_dialog_Closed',
  FRCP_PROMO_IGNORED: 'Fancy_RCP_Promo_dialog_Ignored',
  FRCP_PROMO_NO: 'Fancy_RCP_Promo_dialog_No',
  FRCP_PROMO_SHOWN: 'Fancy_RCP_Promo_dialog',
  FRCP_PROMO_YES: 'Fancy_RCP_Promo_dialog_Yes',
  FREE_TEXT_SEARCH: 'nav.free text search',
  FORM_SUGGESTIONS_CLICK: 'form_suggestions_click',
  GIFT_BAG_DESELECTED: 'gift_bag_deselected',
  GIFT_BAG_SELECTED: 'gift_bag_selected',
  GIVE_FEEDBACK_CLICK: 'give_feedback_click',
  GIVE_POLL_FEEDBACK_CLICK: 'give_poll_feedback_click',
  GLOBAL_GREETING_OPTION_CLICK: 'global_greeting_option_click',
  HELPFUL_SUGGESTION_SHOWN: 'autosuggest_shown',
  HOLIDAY_CATEGORY_BANNER_CLOSED: 'holiday_category_banner_closed',
  IMAGE_LOAD_TIME: 'load_time',
  INSPIRATION_BOARD_CLICK: 'inspiration_board_click',
  INSPIRATION_BOARD_CYCLER_CLICK: 'inspiration_board_cycler_click',
  ITEM_NO_LONGER_AVAILABLE_POPUP_SHOWN: 'item_no_longer_available_popup_shown',
  ITEM_OPTION_BACK_VIEW_CLICK: 'item_option_back_view_click',
  ITEM_OPTION_FOILPRESS_CLICK: 'item_option_foilpress_click',
  LATEST_SUBMISSIONS_CLICK: 'latest_submissions_click',
  LETTERPRESS_ABOUT_PRICING_CLICK: 'letterpress_about_pricing_click',
  LIMITED_EDITION_PRINT_CLICK: 'limited_edition_print_click',
  LIVE_CHAT_CLICK: "contact_chat_click",
  LOGIN_CLICK: "sign_in_click",
  MATERIAL_CHANGE: 'material_change',
  MATERIALS_DROPDOWN_CLICK: 'materials_dropdown_click',
  MATERIALS_INFO_CLICK: 'materials_info_click',
  MERCH_BLOCK_CHANGE_PHOTO_CLICK: 'merch_block_change_photo_click',
  MERCHANDISING_BLOCK_CLICK: 'merchandising_block_click',
  MODULE_CLICK: 'module_click',
  MY_BOARDS_LINK_CLICK: 'my_boards_link_click',
  NEXT_BUTTON_CLICK: 'next_button_click',
  OLD_EXPERIENCE: 'old_experience',
  NEW_BOARD_CLICK: 'new_board_click',
  NAME_ABOVE_INSPIRATION_BOARD_CLICK: 'name_above_inspiration_board_click',
  NAME_BELOW_INSPIRATION_BOARD_CLICK: 'name_below_inspiration_board_click',
  NEW_EXPERIENCE: 'new_experience',
  OPEN: 'open',
  OPT_OUT: 'opt_out',
  ORDER_BUTTON_CLICK: 'order_button_click',
  ORDER_CONFIRM_PAGE_LOAD: 'order_confirm_page_load',
  ORDER_CONFIRM_LINE_ITEM_LOAD: 'order_confirm_line_item_load',
  ORDER_DETAILS_LINK_CLICK: 'order_details_link_click',
  ORDER_DETAILS_PAGE_VIEW: 'order_details_page_view',
  ORDER_NUMBER_CLICK: 'order_number_click',
  ORDER_STATUS_SHOWN: 'order_status_shown',
  ORDERS_PAGE_VIEW: 'orders_page_view',
  PAGE_LINK_CLICK: 'page_link_click',
  PAGE_NUMBER_CLICK: 'page_number_click',
  PAGE_LOAD: 'page_load',
  PAPER_OPTION_CHANGE: 'paper_option_change',
  PAGINATION_CLICK: 'pagination_click',
  PERSONALIZE_CLICK: 'personalize_click',
  PHOTO_TRAY_UPLOAD_PHOTO: 'photo_tray_upload_photo',
  PINIT_BUTTON_CLICK: 'pinit_button_click',
  PO_NUMBER_CLICK: 'po_number_click',
  POST_ORDER_ACTIONS: 'post_order_actions',
  POST_ORDER_EDIT: 'post_order_edit',
  PREVIEW_IMAGE_CLICK: 'preview_image_click',
  PREVIOUS_CHALLENGE_LINK_CLICK: 'previous_challenge_link_click',
  PRINTING_INFO_CLICK: 'printing_info_click',
  PRODUCT_ADDED_TO_FAVORITES: 'product_added_to_favorites',
  PRODUCT_ADMIN_TEMPLATE_UPLOADING_FAILED: 'product_admin_template_uploading_failed',
  PRODUCT_ADMIN_TEMPLATE_UPLOADING_SUCCESS: 'product_admin_template_uploading_success',
  PRODUCT_BACKER_OPTION_CLICK: 'product_backer_option_click',
  PRODUCT_GREETING_OPTION_CLICK: 'product_greeting_option_click',
  PRODUCT_GREETING_CHANGE: 'product_greeting_change',
  PRODUCT_IMAGE_CLICK: 'product_image_click',
  PRODUCT_LINK_CLICK: 'product_link_click',
  PRODUCT_OPTION_CHANGE_CLICK: 'product_option_change_click',
  PRODUCT_OPTION_CHANGE_SHOWN: 'product_option_change_shown',
  PRODUCT_OPTION_DESCRIPTION_TOGGLE: 'product_option_description_toggle',
  PRODUCT_REMOVED_FROM_FAVORITES: 'product_removed_from_favorites',
  PRODUCT_ROW_DRAGGED: 'product_row_dragged',
  PRODUCT_ROW_POSITION_CHANGE: 'product_row_position_change',
  PRODUCT_ROW_ACTION_LINK_CLICK: 'product_row_action_link_click',
  PRODUCT_SHAPE_OPTION_CLICK: 'product_shape_option_click',
  PRODUCT_SHAPE_CHANGE: 'product_shape_change',
  PROMO_BAR_CLICK: 'promo_bar_click',
  PROOF_APPROVE: 'approve_proof',
  PROOF_DOWNLOAD: 'download_proof',
  PROOF_EDIT_ITEM: 'edit_item',
  PROOF_EDIT_SHIPPING_ADDRESS: 'edit_shipping_address',
  PROOF_EDIT_SHIPPING_METHOD: 'edit_shipping_method',
  PROOF_GET_IT_SOONER: 'get_it_sooner',
  PROOF_MANAGE_RCP: 'manage_recipient_addressing',
  PROOF_MESSAGE_NO_PROOF_CLICK: 'proof_message_no_proof_click',
  PROOF_MESSAGE_WEDDING_PROOF_CLICK: 'proof_message_wedding_proof_click',
  PROOF_MESSAGE_DEFAULT_PROOF_CLICK: 'proof_message_default_proof_click',
  PROOF_MESSAGE_DEFAULT_CLICK: 'proof_message_default_click',
  PROOF_REJECT: 'reject_proof',
  PROOF_RCP_DIALOG_POP_UP: 'rcp_pop_up_click',
  PROOF_RCP_PICKER_POP_UP: 'rcp_picker_pop_up',
  QUANTITY_PICKER_CLICK: 'quantity_picker_click',
  QUICKLOOK_BUTTON_CLICK: 'quicklook_button_click',
  RAP_PICKER_CANCELED: 'rap_picker_canceled',
  RAP_PICKER_CLOSED: 'rap_picker_closed',
  RAP_PICKER_CONFIRMED: 'rap_picker_confirmed',
  RAP_PICKER_DISPLAYED: 'rap_picker_displayed',
  RAP_SIDEBAR_CLICKED: 'rap_sidebar_clicked',
  RATE_DESIGN: 'rate_design',
  RCP_PICKER_CANCELED: 'rcp_picker_canceled',
  RCP_PICKER_CLOSED: 'rcp_picker_closed',
  RCP_PICKER_CONFIRMED: 'rcp_picker_confirmed',
  RCP_PICKER_DISPLAYED: 'rcp_picker_displayed',
  RCP_SIDEBAR_CLICKED: 'rcp_sidebar_clicked',
  RECENTLY_VIEWED_PAGINATION_CLICK: 'recently_viewed_pagination_click',
  RECENTLY_VIEWED_SKU_CLICK: 'recently_viewed_sku_click',
  RELATED_CATEGORIES_CLICK: 'related_categories_click',
  RELATED_SKU_CLICK: 'related_sku_click',
  REMOVE_BACKER: 'remove_backer',
  REMOVE_CUSTOM_FOIL: 'remove_custom_foil',
  REMOVE_ENVELOPE: 'remove_envelope',
  REMOVE_FROM_ORDER_CLICK: 'remove_from_order_click',
  REMOVE_LABEL: 'remove_label',
  REMOVE_LINER: 'remove_liner',
  REMOVE_RAP: 'remove_rap',
  REMOVE_RCP: 'remove_rcp',
  REMOVE_SHAPE: 'remove_shape',
  REMOVED_SAVED_CARD: 'removed_saved_card',
  REORDER_BUTTON_CLICK: 'reorder_button_click',
  REORDER_BUTTON_SHOWN: 'reorder_button_shown',
  RESET_FILTERS_CLICK: 'reset_filters_click',
  RETIRED_RELATED_CATEGORIES_CLICK: 'retired_related_categories_click',
  REVIEW_MISSING_CONTENT_CLICK: 'review_missing_content_click',
  REVIEW_MISSING_CONTENT_SHOWN: 'review_missing_content_shown',
  REVIEWORDER_PAGE_LOAD: 'revieworder_page_load',
  REVIEWORDER_LINE_ITEM_LOAD: 'revieworder_line_item_load',
  REVIEW_PROOF_BUTTON_CLICK: 'review_proof_button_click',
  REVIEW_PROOF_BUTTON_SHOWN: 'review_proof_button_shown',
  SAMPLE_DESIGN_MODAL_CANCEL_CLICK: 'sample_design_modal_cancel_click',
  SAMPLE_DESIGN_MODAL_NEXT_CLICK: 'sample_design_modal_next_click',
  SAMPLE_THIS_DESIGN_LINK_CLICK: 'sample_this_design_link_click',
  SAVE: 'save',
  SAVE_CLICK: 'save_click',
  SAVED_CREDIT_CARD_STATUS: 'saved_credit_card_status',
  SEE_ALL_DESIGNS_LINK_CLICK: 'see_all_designs_link_click',
  SEE_ALL_FAVORITE_DESIGNERS_CLICK: 'see_all_favourite_designers_click',
  SEE_CHALLENGE_ARCHIVES_CLICK: 'see_challenge_archives_click',
  SEE_WINNERS_LINK_CLICK: 'see_winners_link_click',
  SEE_OPEN_CHALLENGES_LINK_CLICK: 'see_open_challenges_link_click',
  SELF_SERVE_CLICK: 'self_service_click',
  SELF_SERVE_SHOWN: 'self_service_shown',
  SEARCH_TERM: 'search_term',
  SHAPE_OPTION_CLICK: 'shape_option_click',
  SHARE_DESIGN_EMAIL: 'share_design_email',
  SHARE_ON_FACEBOOK_ICON_CLICK: 'share_on_facebook_icon_click',
  SHARE_ON_PINTEREST_ICON_CLICK: 'share_on_pinterest_icon_click',
  SHARE_ON_TWITTER_ICON_CLICK: 'share_on_twitter_icon_click',
  SHARE_ON_EXTERNAL_SITE_ICON_CLICK: 'share_on_external_site_icon_click',
  SHOP_NOW_LINK_CLICK: 'shop_now_link_click',
  SHOW_LESS_COLORS_CLICK: 'show_less_colors_click',
  SHOW_MORE_COLORS_CLICK: 'show_more_colors_click',
  SIZE_OPTION_CLICK: 'size_option_click',
  SKIP_DESIGN: 'skip_design',
  SKU_CLICK: 'sku_click',
  SORT_DROPDOWN_CLICK: 'sort_dropdown_click',
  SORT_RESULTS: 'sort',
  STANDARD_RAP_OPTION_CLICKED: 'standard_rap_option_clicked',
  STANDARD_RCP_OPTION_CLICKED: 'standard_rcp_option_clicked',
  SUBJECT_ACTIVATE: 'subject_activate',
  SUBMIT_CHANGES: 'submit_changes',
  SUBMIT_CLICK: 'submit_click',
  SUBMIT_CLICK_WITH_ERROR: 'submit_click_with_error',
  SUBMIT_ITEM_DIALOG: 'submit_item_dialog',
  SUBMIT_CLICK_WITH_ORDER_ID: 'submit_with_orderID',
  SUBMIT_A_DESIGN_BUTTON_CLICK: 'submit_a_design_button_click',
  SUBMIT_A_DESIGN_LINK_CLICK: 'submit_a_design_link_click',
  SUBSCRIBE_TO_DESIGN_COMMENTS: 'subscribe_to_design_comments',
  TABS_CLICK: 'tabs_click',
  TOGGLE_2_4_UP: 'toggle_2_4_up',
  TOGGLE_CHANGE_PHOTO: 'toggle_change_photo',
  TRACKING_BUTTON_CLICK: 'tracking_button_click',
  TRACKING_BUTTON_SHOWN: 'tracking_button_shown',
  TRIGGER: 'trigger',
  TURN_OFF_FROM_TOGGLE: 'turn_off_from_toggle',
  TURN_ON_FROM_MERCH_BLOCK: 'turn_on_from_merch_block',
  TURN_ON_FROM_TOGGLE: 'turn_on_from_toggle',
  TURN_ON_MERCH_BLOCK_UPLOAD_PHOTO: 'turn_on_merch_block_upload_photo',
  TURN_ON_MERCH_BLOCK_CHANGE_PHOTO: 'turn_on_merch_block_change_photo',
  TURN_OFF_FROM_MERCH_BLOCK: 'turn_off_from_merch_block',
  UNCURATE_LINK_CLICK: 'uncurate_link_click',
  UPCOMING_EVENT_CLICK: 'upcoming_event_click',
  UPDATE_QUANTITY: 'update quantity',
  UPLOAD: 'Upload',
  UPLOAD_CLICK: 'upload_click',
  UPLOAD_IMAGE_REQUEST: 'upload_image_request',
  UPLOAD_PHOTOS_CLICK: 'upload_photos_click',
  UPLOAD_PHOTOS_SHOWN: 'upload_photos_shown',
  UPSELL_ITEM_CLICK: 'upsell_item_click',
  USER_TERMS_AGREEMENT_CLICK: 'user_terms_agreement_click',
  VOTE_NOW_BUTTON_CLICK: 'vote_now_button_click',
  VOTE_NOW_LINK_CLICK: 'vote_now_link_click',
  VIEW_ALL_CLICK: 'view_all_click',
  VIEW_LESS_CLICK: 'view_less_click',
  PUSH_DOWN_BANNER_CLOSED: 'push_down_banner_closed',
  VIEW_DETAILS_CLICK: 'view_details_click',
  VIEW_DETAILS_SHOWN: 'view_details_shown',
  VIEW_OPTION_CLICK: 'view_option_click',
  VIRAL_LOGO_CHECKBOX_CHECKED: 'viral_logo_checkbox_checked',
  VIRAL_LOGO_CHECKBOX_UNCHECKED: 'viral_logo_checkbox_unchecked',
  VIRAL_LOGO_LEARN_MORE_CLICK: 'viral_logo_learn_more',
  VISIT_EVENT: 'visit',
  VOTING_BADGE_CLICK: 'voting_badge_click',
  WOULD_BUY_THIS_CLICK: 'would_buy_this_click',
  ZOOM_CLICK: 'zoom_click',
  ZOOM_DIALOG_COLORWAY_CLICK: 'zoom_dialog_colorway_click',
  ZOOM_DIALOG_SHAPE_CLICK: 'zoom_dialog_shape_click',
  ZOOM_DIALOG_ALT_GREETING_CLICK: 'zoom_dialog_alt_greeting_click',
  CHANGE_EXCLUSIVE_STATUS: 'change_exclusive_status'
};

M.GA.TRACK_EVENT_RCP_REVIEW = {
  ADD_ADDRESS: 'add_address',
  UPLOAD_ADDRESS_FILE: 'upload_address_file'
};

M.GA.TRACK_EVENT_PROOF_RCP_POP_UP_ACTIONS = {
  ADD_ADDRESSES: 'add_addresses',
  DONT_ADD_ADDRESSES: 'dont_add_addresses',
  CONTINUE: 'continue',
  VISIT_ADDRESS_BOOK: 'visit_address_book',
  CLICK_X: 'click_x'
};

M.GA.TRACK_EVENT_PROOF_BUTTONS = {
  APPROVE: 'approve_proof',
  REJECT: 'reject_proof'
};

M.GA.TRACK_EVENT_WEBFORM_SEARCH_BOX = {
  TEXT_ENTERED: 'search_box_text_entered',
  CLICKED: 'search_clicked',
  AUTOCOMPLETE_CLICKED: 'search_autocomplete_clicked'
};

M.GA.TRACK_EVENT_WEBFORM_TOPICS = {
  TOPIC_CLICKED: 'featured_topic_clicked',
  SEE_ALL_FAQ: 'see_all_FAQ',
  SHOW_MORE_FAQ: 'show_more_FAQs'
};

M.GA.TRACK_EVENT_WEBFORM_EMAIL_US = {
  CONTACT_REASON_DROPDOWN_SELECTED: 'contact_reason_dropdown_selected',
  ORDER_DROPDOWN_SELECTED: 'order_dropdown_selected',
  FILE_UPLOADED: 'file_uploaded',
  SIGN_IN_SIGN_OUT: 'sign_in_sign_out',
  SEND_EMAIL: 'send_email',
  FAQ_SIDEBAR: 'faq_sidebar_triggered',
  FAQ_SIDEBAR_CLICKED: 'faq_sidebar_click'
};

M.GA.TRACK_EVENT_LOGGING_ACTIONS = {
  SIGN_IN: 'sign_in',
  SIGN_OUT: 'sign_out'
};

M.GA.TRACK_EVENT_QUICK_SELF_SERVICE = {
  SELF_SERVICE_LINK_CLICKED: 'self_service_link_clicked'
};

M.GA.TRACK_EVENT_LIVE_CHAT = {
  START_LIVE_CHAT: 'start_live_chat'
};

M.GA.TRACK_EVENT_PHOTO_TRAY = {
  EXPAND_YEAR: 'expand_year',
  COLLAPSE_YEAR: 'collapse_year',
  SORT_BY: 'sort_by',
  CLICK_UPLOAD_PHOTOS: 'click_upload_photos',
  AUTO_ENHANCE_DESELECT: 'auto_enhance_deselect',
  AUTO_ENHANCE_SELECT: 'auto_enhance_select',
  AUTO_ENHANCE_ON: 'auto_enhance_on',
  AUTO_ENHANCE_OFF: 'auto_enhance_off',
  COLOR_COLOR: 'color_color',
  COLOR_SEPIA: 'color_sepia',
  COLOR_BW: 'color_bw',
  ZOOM_IN: 'zoom_in',
  ZOOM_OUT: 'zoom_out',
  ROTATE_LEFT: 'rotate_left',
  ROTATE_RIGHT: 'rotate_right',
  CANCEL: 'cancel',
  SAVE: 'save',
  SHOW_TIPS: 'show_tips',
  FORCED_NEW_PHOTOTRAY: 'luxury_art_forced'
};

// Limited to 5 slots
// https://developers.google.com/analytics/devguides/collection/gajs/gaTrackingCustomVariables
M.GA.CUSTOM_VARIABLE_SLOTS = {
  SHOPPING_CART: 1,
  USER_ROLES: 2,
  SAVED_CREDIT_CARD: 3
};

M.GA.CUSTOM_VARIABLES = {
  SHOPPING_CART: 'ShoppingCart', // unclear what this is used for
  USER_ROLES: 'User Roles', // unclear what this is used for
  SAVED_CREDIT_CARD: 'Saved Credit Card'
};

M.GA.CUSTOM_VARIABLE_SCOPE = {
  VISITOR: 1,
  SESSION: 2,
  PAGE: 3
};

/**
 * Name of cookie used to identify SEM users
 */
M.COOKIE.SEM_USER = 'isSEMUser';
/**
 * Name of cookie used to identify SEO users
 */
M.COOKIE.SEO_USER = 'isSEOUser';

/**
 * Name of cookie used to identify Display Advertising users
 */
M.COOKIE.DISPLAY_ADVERTISING_USER = 'isDisplayAdvertisingUser';

/**
 * Name of cookie used to identify the guid of the last photo uploaded by user
 */
M.COOKIE.PHOTO_CONTINUATION_GUID_COOKIE = 'photo_continuation_guid';

/**
 * Name of cookie used to store an array of skus that the user has
 * been presented the party upsell page for.
 */
M.COOKIE.PARTY_UPSOLD_SKUS = 'party_upsold_skus';

M.COOKIE.PHOTOGRAPHER_SIGNUP_INFO = 'photographer_signup_info';

M.COOKIE.RECIPIENT_ADDRESSING_V2_2013 = 'rcp13';

M.COOKIE.HAS_SEEN_FIND_IT_FAST_DIALOG = 'seen_fif_dialog';

M.COOKIE.COMMUNITY_REBUILD = 'comm_rebuild';

M.COOKIE.AB_HOMEPAGE_REDESIGN = 'ab_homepage_redesign';
M.COOKIE.AB_HOMEPAGE_REDESIGN_VIGNETTE_VS_PUSHDOWN = 'ab_homepage_redesign_vignette_vs_pushdown';

M.COOKIE.AB_CU3_SMOOTH_LOADING = 'ab_cu3_smooth_loading';

M.COOKIE.AB_SHOW_ADDRESS_TAB = 'ab_show_address_tab';

M.COOKIE.AB_DI_USER_SIGNUP = 'ab_di_user_signup';

M.COOKIE.AB_SHOW_NEW_PHOTOTRAY = 'ab_show_new_phototray'

M.COOKIE.AB_RCP_POSITION = 'ab_rcp_position';

M.COOKIE.AB_NAV_RESTRUCTURE = 'ab_nav';

M.COOKIE.AB_EXPRESS_BY_DEFAULT = 'default_express_proofing';

M.COOKIE.AB_HOLIDAY_EXPRESS_DEFAULT = 'ab_holiday_express_default';

M.COOKIE.ABCD_HOLIDAY_EXPRESS = 'abcd_holiday_express';

M.COOKIE.AB_REGISTER_FORM = 'register_form_test';

M.COOKIE.ABC_FACEBOOK_CONNECT = 'fb_connect_2018';

M.COOKIE.AB_AIO_PROOF_PRICING = 'aio_proof_pricing_2018';

M.COOKIE.AB_ADDRESS_BOOK_INCENTIVE = 'address_incentive_2018_3';

M.COOKIE.CU3_VARIABLE_DATA_CUSTOMIZATION = 'cu3_variable_data_customization';

var privacyAssuranceMessage = "We will never share, sell, or otherwise " +
    "disclose your address book to third parties, other than to fulfill your " +
    "orders, and we won't use your contacts to create Minted distribution lists.";

var privacyAssuranceMessageHeader =
    "Your contacts' information is for your use only.";
var privacyPolicyURL = "http://help2.minted.com/articles/General/Privacy-Policy";

M.AB_SHOW_ADDRESS_TAB = M.AB_SHOW_ADDRESS_TAB || {};

M.AB_DI_USER_SIGNUP = M.AB_DI_USER_SIGNUP || {};

M.AB_SHOW_ADDRESS_TAB.PRODUCT_KINDS = ['INV', 'IFS', 'STD', 'SFS'];

M.AB_SHOW_NEW_PHOTOTRAY = M.AB_SHOW_NEW_PHOTOTRAY || {};

/**
* Object for storing drupal node titles
*
* Keep n'sync with NodeTitles in model/constants.py where required
*/
M.NODE_TITLES = M.NODE_TITLES || {};
M.NODE_TITLES.TERMS_ARTIST_STORES = 'artist stores terms and conditions';
M.NODE_TITLES.TERMS_PHOTOGRAPHERS = 'Photographer Terms Modal';

/**
 * MogoTest IP Address. Used for modifying the UI to
 * accomodate our browser screenshot service.
 * http://docs.mogotest.com/display/HOWTO/Filter+Mogotest+Traffic+in+Google+Analytics
 */
M.MOGOTEST_IP = '107.20.231.24';

/**
 * Format option IDs.
 *
 * NOTE: This data is duplicated in
 * drupal/static/src/js/cu3/constants.js.
 * Keep the lists in sync until they are refactored.
 */
M.FormatOptions = {
  FLAT: 1,
  FOLDED_BLANK: 2,
  YEARLINE: 3,
  FOLDED_LETTER: 4,
  FOLDED_TEXT: 16,
  MINIBOOK_A: 17,
  MINIBOOK_B: 18,
  CALENDAR: 39,
  BLANK_NOTEBOOK: 45,
  LINED_NOTEBOOK: 46,
  GRAPH_NOTEBOOK: 48,
  LARGE_CUSTOM_WEDDING_SIGN: 52,
  MONTHLY_PLANNER_NOTEBOOK: 64,
  WEEKLY_PLANNER_NOTEBOOK: 65,
  ADDRESS_BOOK_NOTEBOOK: 66,
  BOOKLETTE_A: 67,
  BOOKLETTE_B: 68,
  BOOKLETTE: 69,
  DIGITAL_INVITATION: 76,
  ONE_OUNCE_STAMP: 88,
  TWO_OUNCE_STAMP: 89,
  POSTCARD_STAMP: 90,
  ALL_IN_ONE: 112,
  GRID_NOTEBOOK: 123,
  DAILY_NOTEBOOK: 124,
  WEEKLY_NOTEBOOK: 125,
};

M.BindingOptions = {
  GROMMETED: 0,
  SPIRAL: 1
};

/**
 * Object for storing sku related constants
 * NOTE: We may want to rename this, but these constants are not limited to
 * Cu3 which is why they're here rather than cu3/constants.js
 */
M.SKU = M.SKU || {};

/**
 * NOTE: Keep this in sync with BUNDLE_CUSTOMIZABLE_PRODUCT_TYPES in
 * minted/model/constants.py
 */
M.SKU.PARTY_PERSONALIZABLE = ['PBB', 'PGS', 'PG2', 'PTS', 'PT2', 'PBM', 'PRN', 'PBD'];
M.SKU.PARTY_DISABLE_ADDONS = ['PBB', 'PBM'];
M.SKU.PARTY_PICK_AND_PACK_KINDS = [
  'PLA', 'PPN', 'PSR', 'PCU', 'PFB', 'PCK', 'PAJ', 'PWT', 'XX9', 'PTW'];
M.SKU.CROWDLAUNCH_PARTY_PRODUCT_TYPES = ['GCS', 'GSS', 'PBB', 'PBC', 'PBS',
    'PCC', 'PCR', 'PCT', 'PFS', 'PPC', 'PPW', 'PSN', 'PSS', 'PTC', 'PWG',
    'PGS', 'PG2', 'PTS', 'PT2'];
M.SKU.LARGER_QUICKLOOK_IMAGE = ['PRN', 'PBD'];
// keep in sync with HAS_STATIONERY_LOGO in model/constants.py
M.SKU.HAS_STATIONERY_LOGO = ['BST', 'FPS', 'KST', 'PST', 'RSP',
    'SPC', 'HPC', 'VPC', 'BPC', 'GPC', 'BBC', 'RPC', 'CPC', 'FBC',
    'FPC', 'APC', 'MPC', 'FAP', 'GPF', 'C2P', 'SPF', 'NCC', 'PNC',
    'FBP', 'BCC', 'HAP', 'HPF', 'RHP', 'DPC', 'HWP', 'TXP', 'TFP',
    'LPC', 'DFP', 'TPC', 'EDP', 'EPC', 'HGP', 'PSY', 'FST', 'MTA',
    'MTG', 'MTE', 'MTD'];
M.SKU.RSVP_CARD = ['RSV'];
/**
 * Array of pre-defined colors for the ColorElementPicker dialog.
 */
M.COLOR_ELEMENTS = M.COLOR_ELEMENTS || {};
M.COLOR_ELEMENTS.DEFAULT_COLORS = [
  {cmykHex: '#47303005', name: 'Matte Silver'},
  {cmykHex: '#496B7705', name: 'Matte Gold'},
  {cmykHex: '#032BED08', name: 'Dandelion'},
  {cmykHex: '#006B6100', name: 'Peach'},
  {cmykHex: '#756B1A08', name: 'Lavender'},
  {cmykHex: '#47001F00', name: 'Turquoise'},
  {cmykHex: '#2E00FA14', name: 'Lime'},
  {cmykHex: '#8200E60A', name: 'Pear'},
  {cmykHex: '#573D5205', name: 'Ash'},
  {cmykHex: '#2E8FDB40', name: 'Toffee'},
  {cmykHex: '#1C4DBF0A', name: 'Faux Gold'},
  {cmykHex: '#00BA6E00', name: 'Tulip'},
  {cmykHex: '#69D10000', name: 'Amethyst'},
  {cmykHex: '#51001A00', name: 'Pool'},
  {cmykHex: '#611F7005', name: 'Mint'},
  {cmykHex: '#E800C700', name: 'Shamrock'},
  {cmykHex: '#3F2D2682', name: 'Gravel'},
  {cmykHex: '#2BA3E066', name: 'Burnt Sienna'},
  {cmykHex: '#0078ED0D', name: 'Pumpkin'},
  {cmykHex: '#03E82E05', name: 'Azalea'},
  {cmykHex: '#E2F40726', name: 'Purple'},
  {cmykHex: '#6E140F00', name: 'Sky Blue'},
  {cmykHex: '#FFA6032B', name: 'Lapis'},
  {cmykHex: '#3829CF38', name: 'Surplus Green'},
  {cmykHex: '#B28A9E4F', name: 'Pewter'},
  {cmykHex: '#4285D682', name: 'Coffee'},
  {cmykHex: '#12C4B221', name: 'Rosewood'},
  {cmykHex: '#03E8B808', name: 'Scarlet'},
  {cmykHex: '#0CEF4444', name: 'Merlot'},
  {cmykHex: '#94431500', name: 'Provincial Blue'},
  {cmykHex: '#F0781C73', name: 'Aegean'},
  {cmykHex: '#7A45C754', name: 'Moss'},
  {cmykHex: '#DBB06E8C', name: 'Black'},
  {cmykHex: '#8580851A', name: 'Graphite'},
  {cmykHex: '#00914900', name: 'Rose'},
  {cmykHex: '#428E990F', name: 'Dusty Rose'},
  {cmykHex: '#824FD116', name: 'Pistachio'},
  {cmykHex: '#DBD30000', name: 'Blue Violet'},
  {cmykHex: '#C944AD19', name: 'Cucumber'},
  {cmykHex: '#C96B4707', name: 'Denim'},
  {cmykHex: '#89514F02', name: 'Stone'},
  {cmykHex: '#E2EF0726', name: 'Grape'},
  {cmykHex: '#2D00F900', name: 'Avocado'},
  {cmykHex: '#6B024400', name: 'Seafoam'},
  {cmykHex: '#63C64C0A', name: 'Boysenberry'},
  {cmykHex: '#DB770000', name: 'Sapphire'},
  {cmykHex: '#D6A05928', name: 'Indigo'},
  {cmykHex: '#6D590000', name: 'Periwinkle'},
  {cmykHex: '#DBAF7A8C', name: 'Soft Black'},
  {cmykHex: '#001C0700', name: 'Pale Pink'},
  {cmykHex: '#42708E07', name: 'Matte Gold'},
  {cmykHex: '#009B8C00', name: 'Neon Orange'},
  {cmykHex: '#1E333F00', name: 'Latte'},
  {cmykHex: '#00D30000', name: 'Neon Pink'},
  {cmykHex: '#00D6DB00', name: 'Verona Sunset'}
];

M.COLOR_ELEMENTS.LIGHT_COLORS = [
  {cmykHex: '#080F171A', name: 'Dove Grey'},
  {cmykHex: '#001CB200', name: 'Lemon'},
  {cmykHex: '#00333300', name: 'Nude'},
  {cmykHex: '#00401A00', name: 'Classic Pink'},
  {cmykHex: '#30330A00', name: 'Wisteria'},
  {cmykHex: '#29000D00', name: 'Powder Blue'},
  {cmykHex: '#2E082A00', name: 'Mist'},
  {cmykHex: '#36036100', name: 'Tea Green'},
  {cmykHex: '#0A0D0A00', name: 'Blind Deboss (inkless impression)'}
];

M.COLOR_ELEMENTS.ALL_COLORS = M.COLOR_ELEMENTS.DEFAULT_COLORS.concat(
    M.COLOR_ELEMENTS.LIGHT_COLORS);

/**
 * Array of pre-defined colors for use in custom sample orders
 * and for the custom colors dialog in CU3
 */

M.CUSTOM_COLORS = M.CUSTOM_COLORS || {};

/**
 * Array of pre-defined colors for letterpress custom colors
 */
M.CUSTOM_COLORS.LETTERPRESS_COLORS = [
  [
    {rgb: 'AF205B', name: 'Merlot'},
    {rgb: 'C85547', name: 'Rosewood'},
    {rgb: 'E33B45', name: 'Scarlet'},
    {rgb: 'E5397E', name: 'Azalea Pink'},
    {rgb: 'F26B73', name: 'Tulip'},
    {rgb: 'F48B91', name: 'Rose'},
    {rgb: 'F8A691', name: 'Peach'},
  ],
  [
    {rgb: 'EB922A', name: 'Pumpkin'},
    {rgb: 'F4C827', name: 'Dandelion'},
    {rgb: 'D9AB57', name: 'Faux Gold'},
    {rgb: '6F4C22', name: 'Coffee'},
    {rgb: '8B4D22', name: 'Burnt Sienna'},
    {rgb: 'A46731', name: 'Toffee'},
    {rgb: 'B67965', name: 'Dusty Rose'},
  ],
  [
    {rgb: '697643', name: 'Moss'},
    {rgb: '828D50', name: 'Pistachio'},
    {rgb: 'A69F45', name: 'Surplus Green'},
    {rgb: '9FBB9A', name: 'Mint'},
    {rgb: '34856A', name: 'Cucumber'},
    {rgb: '00AC6F', name: 'Shamrock'},
    {rgb: '83BE4E', name: 'Pear'},
    {rgb: 'CAD023', name: 'Avocado'},
  ],
  [
    {rgb: '004970', name: 'Aegean'},
    {rgb: '395775', name: 'Indigo'},
    {rgb: '3D7D9B', name: 'Denim'},
    {rgb: '7D98A3', name: 'Stone'},
    {rgb: '005295', name: 'Lapis'},
    {rgb: '0678BE', name: 'Sapphire'},
    {rgb: '6CA1C9', name: 'Provincial Blue'},
    {rgb: '8CC6E0', name: 'Sky Blue'},
    {rgb: 'A9DDE4', name: 'Pool'},
    {rgb: '91D1C4', name: 'Seafoam'},
  ],
  [
    {rgb: '3F2C7F', name: 'Grape'},
    {rgb: '9F509F', name: 'Amethyst'},
    {rgb: '9E547B', name: 'Boysenberry'},
    {rgb: '444A9F', name: 'Blue Violet'},
    {rgb: '8C8AB1', name: 'Heather'},
    {rgb: '929CCE', name: 'Periwinkle'},
  ],
  [
    {rgb: '000000', name: 'Soft Black'},
    {rgb: '4B5650', name: 'Pewter'},
    {rgb: '7F746F', name: 'Graphite'},
    {rgb: '6E7277', name: 'Gravel'},
    {rgb: 'A8ADA4', name: 'Ash'},
    {rgb: 'B59281', name: 'Matte Gold'},
    {rgb: 'B4BABD', name: 'Matte Silver'},
    {rgb: 'F4826C', name: 'Neon Orange'},
    {rgb: 'EF539E', name: 'Neon Pink'},
  ],
  [
    {rgb: 'FACACC', name: 'Classic Pink'},
    {rgb: 'FCE6E7', name: 'Pale Pink'},
    {rgb: 'FCD3C1', name: 'Nude'},
    {rgb: 'FFDE6A', name: 'Lemon'},
    {rgb: 'DEC7B7', name: 'Latte'},
    {rgb: 'D0E2D7', name: 'Mist'},
    {rgb: 'CCE1B0', name: 'Tea Green'},
    {rgb: 'D3EDF0', name: 'Powder Blue'},
    {rgb: 'B5E1E1', name: 'Turquoise'},
    {rgb: 'CBC4D9', name: 'Wisteria'},
    {rgb: 'DDD6CF', name: 'Dove Grey'},
    {rgb: 'F1EDEC', name: 'Blind Deboss'},
    {rgb: 'F05136', name: 'Verona Sunset'},
  ],
]

M.CUSTOM_COLORS.LETTERPRESS_COLORS_DICT = {
  'AF205B':'Merlot',
  'C85547': 'Rosewood',
  'E33B45': 'Scarlet',
  'E5397E': 'Azalea Pink',
  'F26B73': 'Tulip',
  'F48B91': 'Rose',
  'F8A691': 'Peach',
  'EB922A': 'Pumpkin',
  'F4C827': 'Dandelion',
  'D9AB57': 'Faux Gold',
  '6F4C22': 'Coffee',
  '8B4D22': 'Burnt Sienna',
  'A46731': 'Toffee',
  'B67965': 'Dusty Rose',
  '697643': 'Moss',
  '828D50': 'Pistachio',
  'A69F45': 'Surplus Green',
  '9FBB9A': 'Mint',
  '34856A': 'Cucumber',
  '00AC6F': 'Shamrock',
  '83BE4E': 'Pear',
  'CAD023': 'Avocado',
  '004970': 'Aegean',
  '395775': 'Indigo',
  '3D7D9B': 'Denim',
  '7D98A3': 'Stone',
  '005295': 'Lapis',
  '0678BE': 'Sapphire',
  '6CA1C9': 'Provincial Blue',
  '8CC6E0': 'Sky Blue',
  'A9DDE4': 'Pool',
  '91D1C4': 'Seafoam',
  '3F2C7F': 'Grape',
  '9F509F': 'Amethyst',
  '9E547B': 'Boysenberry',
  '444A9F': 'Blue Violet',
  '8C8AB1': 'Heather',
  '929CCE': 'Periwinkle',
  '000000': 'Soft Black',
  '4B5650': 'Pewter',
  '7F746F': 'Graphite',
  '6E7277': 'Gravel',
  'A8ADA4': 'Ash',
  'B59281': 'Matte Gold',
  'B4BABD': 'Matte Silver',
  'F4826C': 'Neon Orange',
  'EF539E': 'Neon Pink',
  'FACACC': 'Classic Pink',
  'FCE6E7': 'Pale Pink',
  'FCD3C1': 'Nude',
  'FFDE6A': 'Lemon',
  'DEC7B7': 'Latte',
  'D0E2D7': 'Mist',
  'CCE1B0': 'Tea Green',
  'D3EDF0': 'Powder Blue',
  'B5E1E1': 'Turquoise',
  'CBC4D9': 'Wisteria',
  'DDD6CF': 'Dove Grey',
  'F1EDEC': 'Blind Deboss',
  'F05136': 'Verona Sunset'
};

M.CUSTOM_COLORS.LETTERPRESS_COLORS_CMYK = [
  [5,94,27,27],
  [7,77,70,13],
  [1,91,72,3],
  [1,91,18,2],
  [0,73,43,0],
  [0,57,29,0],
  [0,42,38,0],
  [0,47,93,5],
  [1,17,93,3],
  [11,30,75,4],
  [26,52,84,51],
  [17,64,88,40],
  [18,56,86,25],
  [26,56,60,6],
  [48,27,78,33],
  [51,31,82,9],
  [22,16,81,22],
  [38,12,44,2],
  [79,27,68,10],
  [91,0,78,0],
  [51,0,90,4],
  [18,0,98,0],
  [100,65,1,17],
  [86,47,0,0],
  [58,26,8,0],
  [43,8,6,0],
  [32,0,10,0],
  [42,1,27,0],
  [94,47,11,45],
  [84,63,35,16],
  [79,42,28,3],
  [54,32,31,1],
  [89,94,3,15],
  [41,82,0,0],
  [39,78,30,4],
  [86,83,0,0],
  [46,42,10,3],
  [43,35,0,0],
  [86,69,48,55],
  [70,54,62,31],
  [52,50,52,10],
  [25,18,15,51],
  [34,24,32,2],
  [26,44,56,3],
  [28,19,19,2],
  [0,61,55,0],
  [0,83,0,0],
  //light colors
  [0,25,10,0],
  [0,11,3,0],
  [0,20,20,0],
  [0,11,70,0],
  [12,20,25,0],
  [18,3,16,0],
  [21,1,38,0],
  [16,0,5,0],
  [28,0,12,0],
  [19,20,4,0],
  [3,6,9,10],
  [4,5,4,0],
  [0,84,86,0]
];

M.CUSTOM_COLORS.DEFAULT_COLORS = [
  [
    { rgb: '1B2E59', name: 'Navy' }, { rgb: '0C4D8A', name: 'Cobalt' },
    { rgb: '3B7FC2', name: 'Cornflower' }, { rgb: '8297AA', name: 'Blue Slate' },
    { rgb: 'A7C6E3',name: 'Dusty Blue' },{ rgb: '91CCD5', name: 'Sea' },
    { rgb: 'B9E3E9', name: 'Aqua' }, { rgb: 'E5F4F3', name: 'Baby Blue' }
  ],
  [
    { rgb: '517542', name: 'Forest' }, { rgb: '5D6529', name: 'Olive' },
    { rgb: '70923F', name: 'Grass' }, { rgb: '009E5D', name: 'Emerald' },
    { rgb: 'BCD12C', name: 'Lime' }, { rgb: 'CDE1AE',name: 'Sage' },
    { rgb: 'E5EBD1', name: 'Celery' }
  ],
  [
   { rgb: 'EF7124', name: 'Carrot' }, { rgb: 'EEA320', name: 'Tangerine' },
   { rgb: 'CE9B2C', name: 'Mustard' }, { rgb: 'F0DE43', name: 'Mimosa' },
   { rgb: 'FBEBA2', name: 'Buttercup' }
  ],
  [
   { rgb: '891632', name: 'Burgundy' }, { rgb: 'CD2823', name: 'Ruby' },
   { rgb: 'EF3B36', name: 'Cherry' }, { rgb: 'EF6A6A',name: 'Salmon' },
   { rgb: 'EC9485',name: 'Apricot' }, { rgb: 'EE3A80',name: 'Fuschia' },
   { rgb: 'F6C4C3', name: 'Petal' }, { rgb: 'FDDFD8', name: 'Blush' }
  ],
  [
   { rgb: '371C58', name: 'Eggplant' }, { rgb: '682468', name: 'Plum' },
   { rgb: '9F4F9E', name: 'Orchid' }, { rgb: '89779E', name: 'Lavender' },
   { rgb: 'BAB2C0', name: 'Lilac' }, { rgb: 'E1E2F2', name: 'Dusk' }
  ],
  [
   { rgb: '0C0D10', name: 'Black' }, { rgb: '515151', name: 'Charcoal' },
   { rgb: '757264', name: 'Warm Grey' }, { rgb: '7A7A7A', name: 'Cool Grey' },
   { rgb: 'B2ADA3', name: 'Slate' }, { rgb: 'D7D7D3', name: 'Cement' }
  ],
  [
   { rgb: '322212', name: 'Chocolate' }, { rgb: '674C2E', name: 'Earth' },
   { rgb: 'C37233', name: 'Caramel' }, { rgb: 'DCD2C7', name: 'Taupe' },
   { rgb: 'F7F0E8', name: 'Tusk' }, { rgb: 'FFF6ED', name: 'Ecru' },
   { rgb: 'FFFFFF', name: 'Cotton' }
  ]
];


/**
 * Keep in sync with src/py/minted/logic/constants.py
 */

M.PRODUCT_IMAGE = M.PRODUCT_IMAGE || {};
M.PRODUCT_IMAGE.PHOTO_CODE = {
  ACP: 'ACP',
  APF: 'APF',
  APU: 'APU',
  APDF: 'APDF',
  APDU: 'APDU',
  APZ: 'APZ',
  CP: 'CP', // Category page size
  PD: 'PD',
  PZ: 'PZ', // Product details zoom shot
  QL: 'QL', // Quicklook size
  TH: 'TH', // Thumbnail (displayed under the product shot on a PDP page)
  HDC: 'HDC'
};

M.PRODUCT_IMAGE.VIEW_CODE = {
  FRONT_COMPOSITE: '001',
  BACKER: '002',
  TABLET: '005',
  BACKER_CURL_UP: '010B',
  WHITE_FRAME: '002A',
  BLACK_FRAME: '002B',
  WOOD_FRAME: '002F',
  WHITE_FRAME_TIER2: '002G',
  BLACK_FRAME_TIER2: '002H',
  BACKER_OPTIONS: '002C',
  INTERIOR: '002D',
  INTERIOR_PARTIAL: '002E',
  QUICKLOOK: '004',
  FRONT: '007',
  FRONT_WITH_SHAPE: '011',
  HOME_DECOR_PRIMARY: '011A',
  SEARCH: '007B',
  FOLDED: '012',
  FRONT_SPIRAL_JOURNAL: '001E'
};

M.PRODUCT_IMAGE.LAYOUT_NAME = {
  L1: 'L1',
  L2: 'L2',
  L3: 'L3'
};

M.PRODUCT_IMAGE.LAYOUT_MAPPINGS = {
  '007_L1': '007',
  '007B_L1': '007B',
  '007B_L2': '011B',
  '007B_L3': '011C',
  '001_L1': '001',
  '001_L2': '001B',
  '001_L3': '001C'
};

/**
 * Local storage keys
 */
M.LOCAL_STORAGE_KEYS = {
  CATEGORY: {
    INTRODUCE_FILTERS: 'CATEGORY.INTRODUCE_FILTERS',
    FLAG_SEEN_ALT_GREETING_HELP: 'CATEGORY.FLAG_SEEN_ALT_GREETING_HELP',
    FLAG_SEEN_RECENTLY_VIEWED_TOOLTIP: 'CATEGORY.FLAG_SEEN_RECENTLY_VIEWED_TOOLTIP'
  },
  HOME: {
    FLAG_HAS_CLOSED_PUSH_DOWN_BANNER: 'HOME.FLAG_HAS_CLOSED_PUSH_DOWN_BANNER'
  },
  CU3: {
    PHOTO_SELECTIONS_BY_PROJECT: 'PHOTO_SELECTIONS_BY_PROJECT',
    PHOTO_SELECTIONS_BY_PROJECT_ID: 'PHOTO_SELECTIONS_BY_PROJECT_',
    FIRST_TIME_TOOLTIP_SKUS: 'FIRST_TIME_TOOLTIP_SKUS',
    TWO_TIME_TOOLTIP_SKUS: 'TWO_TIME_TOOLTIP_SKUS',
    FIRST_TIME_STAMP_TOOLTIP_SKUS: 'FIRST_TIME_STAMP_TOOLTIP_SKUS',
    TWO_TIME_STAMP_TOOLTIP_SKUS: 'TWO_TIME_STAMP_TOOLTIP_SKUS'
  },
  NOTIFICATION: {
    SEGMENT_OPT_OUT: {
      WEDDING: 'NOTIFICATION.SEGMENT_OPT_OUT.WEDDING'
    }
  },
  COMMUNITY: {
    CHALLENGE_HUB: {
      SHOW_SUBMISSIONS_PANEL_EXPANDED:
        'COMMUNITY.CHALLENGE_HUB.SHOW_SUBMISSIONS_PANEL_EXPANDED',
      SHOW_WINNERS_PANEL_EXPANDED:
        'COMMUNITY.CHALLENGE_HUB.SHOW_WINNERS_PANEL_EXPANDED',
      SHOW_SPECIAL_PRIZE_WINNERS_PANEL_EXPANDED:
        'COMMUNITY.CHALLENGE_HUB.SHOW_SPECIAL_PRIZE_WINNERS_PANEL_EXPANDED',
      SHOW_LEADERBOARD_PANEL_EXPANDED:
        'COMMUNITY.CHALLENGE_HUB.SHOW_LEADERBOARD_PANEL_EXPANDED',
      SORTED_BY_SELECTED_OPTION:
        'COMMUNITY.CHALLENGE_HUB.SUBMISSIONS.SORTED_BY_SELECTED_OPTION'
    }
  }

};

/**
 * Keep in sync with src/py/minted/logic/constants.py
 */
M.PHOTO_UPLOAD_STATUS = {
    SUCCESS: 0,
    FAILURE_EXTENSION_NOT_VALID: 1
};

/**
 * Keep in sync with src/py/minted/logic/constants.py - ArtFrameOptions
 *
 * TODO: remove this code and all uses of it and instead get values
 * from frame_option table
 */
M.ART_FRAME = {};

// Shared between tier 1 and 2 paper options
M.ART_FRAME.COMMON_FRAME_OPTIONS = {};

/**
 * List of die cut shape IDs.  NOTE: This is a copy of the list in
 * minted/logic/diecut.py and the two lists should be kept in sync.
 * Currently this is only used in cu3, but the list is included here
 * in anticipation of the list of shapes being needed outside of cu3
 * too.
 */
M.DIECUT.SHAPE = {};

M.DIECUT.ATTRIBUTE_NAME_FOR_SHAPE = {};

M.DIECUT.ATTRIBUTE_NAME_TO_LABEL = {};

M.DIECUT.PUNCHED_TO_UNPUNCHED_SHAPE = {};

M.DIECUT.UNPUNCHED_TO_PUNCHED_SHAPE = {};

/**
 * PRODUCT_OPTIONS_DATA is the response from product options service:
 * https://api-product-options.qa.nonprod.mntd.cc/v1/options
 * and should already be set in base.mako and base_cacheable.mako and page.tpl.php
 * it must be used anywhere on the frontend to get the options data instead of hardcoding
 *
 * @param none
 * @returns product options json
 */
M.productOptionsService = function() {

  if (typeof M.PRODUCT_OPTIONS_DATA !== 'undefined') {
    return M.PRODUCT_OPTIONS_DATA;
  }

  return undefined;
};

/**
 * Format & set the M.ART_FRAME constants
 *
 * @param none
 * @return none
 */
M.setFrameOptionConstants = function() {
  var options = M.productOptionsService();
  if (typeof options === 'undefined' ||
      typeof options.frame === 'undefined') {
      return;
  }

  for (var key in options.frame) {
    if (typeof options.frame[key].option_id !== 'undefined') {
      M.ART_FRAME[key.toUpperCase()] = options.frame[key].option_id;
      M.ART_FRAME.COMMON_FRAME_OPTIONS[options.frame[key].option_id] = options.frame[key].display_name;
    }
  }
};

M.setDieCutShapeConstants = function() {
  var options = M.productOptionsService();
  if (typeof options === 'undefined' ||
      typeof options.shape === 'undefined') {
    return;
  }

  for (var key in options.shape) {
    var shape = options.shape;
    if (typeof shape[key].option_id !== 'undefined') {
      M.DIECUT.SHAPE[key] = shape[key].option_id;
      M.DIECUT.ATTRIBUTE_NAME_FOR_SHAPE[shape[key].option_id] = key;
      M.DIECUT.ATTRIBUTE_NAME_TO_LABEL[key] = shape[key].display_name;

      var regex = /(_|\-)(holepunch|punchhole)$/g;
      if(key.match(regex)){
        var unpunched_name = '';
        if(key.startsWith('default_')) {
          unpunched_name = 'default';
        } else{
          unpunched_name = key.replace(regex, '');
        }

        M.DIECUT.PUNCHED_TO_UNPUNCHED_SHAPE[key] = unpunched_name;
        if(unpunched_name!='default') {
          M.DIECUT.UNPUNCHED_TO_PUNCHED_SHAPE[unpunched_name] = key;
        }
      }
    }
  }
};

M.setFrameOptionConstants();
M.setDieCutShapeConstants();

/**
 * ENVELOPE_OPTION_MAPPINGS is the response from product options service:
 * https://api-product-options.qa.nonprod.mntd.cc/v1/envelope-option-mappings
 * and should already be set in base.mako and base_cacheable.mako and
 * it must be used anywhere on the frontend to get the envelope-option-mappings data instead of hardcoding
 *
 * @returns envelope option mappings json
 */
M.envelopeOptionMappingsService = function() {
  if (typeof M.ENVELOPE_OPTION_MAPPINGS !== 'undefined') {
    return M.ENVELOPE_OPTION_MAPPINGS;
  }
  return undefined;
};

/**
 * Formats & sets the M.ENVELOPE_COLOR_OPTION constants
 * @param nameKey {string}
 * @param index {number}
*/
M.setEnvelopeColorOption = function(nameKey, index) {
  M.ENVELOPE_COLOR_OPTION[nameKey] = index;
}

/**
 * Formats & sets the M.ENVELOPE_COLOR_ID constants
 * @param nameKey {string}
 * @param envelopeColorId {number}
 */
M.setEnvelopeColorId = function(nameKey, envelopeColorId) {
  M.ENVELOPE_COLOR_ID[nameKey] = envelopeColorId;
}

/**
 * Formats & sets the ENVELOPE_ALL_BLACK_INK_COLOR_IDS constants
 * @param isEnvelopeAllBlackInkColorValue {boolean | null}
 * @param envelopeColorId {number}
 */
M.setIsEnvelopeAllBlackInkColor = function(isEnvelopeAllBlackInkColorValue, envelopeColorId) {
  var isEnvelopeAllBlackInkColor = isEnvelopeAllBlackInkColorValue !== null ?
      isEnvelopeAllBlackInkColorValue : false;
  if (isEnvelopeAllBlackInkColor) {
    M.ENVELOPE_ALL_BLACK_INK_COLOR_IDS.push(envelopeColorId);
  }
}

/**
 * Formats & sets the NON_COLORED_ENVELOPE_COLOR_IDS constants
 * @param isNonColoredEnvelopeColorValue {boolean | null}
 * @param envelopeColorId {number}
 */
M.setIsNonColoredEnvelopeColor = function(isNonColoredEnvelopeColorValue, envelopeColorId) {
  var isNonColoredEnvelopeColor = isNonColoredEnvelopeColorValue !== null ?
      isNonColoredEnvelopeColorValue : false;
  if (isNonColoredEnvelopeColor) {
    M.NON_COLORED_ENVELOPE_COLOR_IDS.push(envelopeColorId);
  }
}

/**
 * Formats & sets the envelope option mappings constants
 */
M.setEnvelopeOptionMappingsConstants = function() {
  var options = M.envelopeOptionMappingsService();
  if (typeof options !== 'undefined') {
    $.each(options, function(key, option) {
      var space = ' ';
      var underscore = '_';
      var index = option['envelope_option_index'];
      var name = option['envelope_color_name'];
      var nameKey = name.toUpperCase().replaceAll(space, underscore);
      var envelopeColorId = option['envelope_color_id'];
      M.setEnvelopeColorOption(nameKey, index);
      M.setEnvelopeColorId(nameKey, envelopeColorId);
      M.ENVELOPE_COLOR_OPTION_NAME_TO_IDX[name] = index;
      M.ENVELOPE_INK_OPTIONS[name] = {
        black: option['ink_option_black'],
        white: option['ink_option_white'],
        cmyk: option['ink_option_cmyk'],
      };
      M.ENVELOPE_FIXED_INK_OPTION[name] = option['ink_option_fixed'];
      M.setIsEnvelopeAllBlackInkColor(option['is_envelope_all_black_ink_color'], envelopeColorId);
      M.setIsNonColoredEnvelopeColor(option['is_non_colored_envelope_color'], envelopeColorId);
    });
    M.ENVELOPE_COLOR_OPTION_NAME_TO_IDX['soft white'] = 1;
  }
};

/* A list of product kind categories */
M.CATEGORY = {};
M.CATEGORY.CALENDAR = 'calendar';
M.CATEGORY.WEDDING  = 'wedding';
M.CATEGORY.NOTEBOOK = 'notebook';
M.CATEGORY.BUSINESS = 'business';
M.CATEGORY.ENVELOPES = 'envelopes';

// A list of frame options that cannot be compatible with signature.
M.ART_FRAME.FRAME_OPTIONS_INCOMPATIBLE_WITH_SIGNATURE = [
  M.ART_FRAME.OVAL
];

// Shared between /view/product_details and /cu3 so moved here
M.ENVELOPE_STANDARD_TEMPLATE = {
  COLOR_BLACK: '#000000FF', // cmyk black
  COLOR_WHITE: '#00000000', // cmyk white
  STROKE_COLOR: null,
  ALIGN: 'center'
};

M.ENVELOPE_COLOR_OPTION = {};
M.ENVELOPE_COLOR_OPTION_NAME_TO_IDX = {};



M.ENVELOPE_COLOR_ID = {};
M.ENVELOPE_ALL_BLACK_INK_COLOR_IDS = [];
M.NON_COLORED_ENVELOPE_COLOR_IDS = [];
M.ENVELOPE_INK_OPTIONS = {};
M.ENVELOPE_FIXED_INK_OPTION = {};
M.setEnvelopeOptionMappingsConstants();
var EnvelopeColorOption = M.ENVELOPE_COLOR_OPTION;
var EnvelopeColorOptionNameToId = M.ENVELOPE_COLOR_OPTION_NAME_TO_IDX;


/**
 * Keep in sync with src\py\minted\model\constants.py
 * PricingConstants.FREE_WHITE_ENVELOPE_IDS
 */ 
M.FREE_WHITE_ENVELOPE_IDS = [
  M.ENVELOPE_COLOR_ID['WHITE'],
  M.ENVELOPE_COLOR_ID['RECYCLED_BRILLIANT_WHITE'],
  M.ENVELOPE_COLOR_ID['BRIGHT_WHITE_EURO_FLAP']
];
M.FREE_WHITE_ENVELOPE_COLOR_OPTION_IDS = [
  EnvelopeColorOption['WHITE'],
  EnvelopeColorOption['RECYCLED_BRILLIANT_WHITE'],
  EnvelopeColorOption['BRIGHT_WHITE_EURO_FLAP']
]

var FreeWhiteEnvelopeColorOptionIds = M.FREE_WHITE_ENVELOPE_COLOR_OPTION_IDS;

// Keep in sync with minted.model.constants.M.TemplateType
M.TemplateType = {
  FRONT: 0,
  INTERIOR: 1,
  BACKER: 2,
  CUSTOM_INTERIOR: 3,
  FOLDED: 1,
  // CALENDAR_MONTH: 4, Deprecated
  MINIBOOK: 5,
  LINER: 6,
  LABEL: 7,

  ENVELOPE_BACK: 8,
  ENVELOPE_FRONT_RAP: 13,
  ENVELOPE_FRONT_RCP: 14,
  ENVELOPE_FRONT_RAP_RCP: 15,
  ENVELOPE_OPEN: 16,

  NOTEBOOK_FRONT_OUTER_COVER: 9,
  NOTEBOOK_FRONT_INSIDE_COVER: 10,
  NOTEBOOK_BACK_INSIDE_COVER: 11,
  NOTEBOOK_BACK_OUTER_COVER: 12,

  BOOKLETTE_INTERIOR: 17,

  SPECIAL_GENERAL: 20,
  SPECIAL_FRONT: 21,
  SPECIAL_INTERIOR: 22,
  SPECIAL_BACKER: 23,
  SPECIAL_OPEN: 24,
  SPECIAL_RAP: 25,
  SPECIAL_DIECUT: 26,
  SPECIAL_ENVELOPE: 27,
  PRINT: 28
};

M.TemplateType.MAIN_TYPES = [
  M.TemplateType.FRONT,
  M.TemplateType.BACKER,
  M.TemplateType.INTERIOR
];

M.TemplateType.RAP_TYPES = [
  M.TemplateType.ENVELOPE_FRONT_RAP,
  M.TemplateType.ENVELOPE_BACK
];

M.TemplateType.RCP_TYPES = [
  M.TemplateType.ENVELOPE_FRONT_RCP,
  M.TemplateType.ENVELOPE_FRONT_RAP_RCP,
  M.TemplateType.ENVELOPE_OPEN
];

M.TemplateType.ENVELOPE_TYPES = [
  M.TemplateType.ENVELOPE_BACK,
  M.TemplateType.ENVELOPE_FRONT_RAP,
  M.TemplateType.ENVELOPE_FRONT_RCP,
  M.TemplateType.ENVELOPE_FRONT_RAP_RCP,
  M.TemplateType.ENVELOPE_OPEN
];

M.MAX_SIDE_LENGTH_PDP = 550;
M.MAX_SIDE_LENGTH_ORDERS_PAGE = 150;

M.OCCASION_DATE = {};
M.OCCASION_DATE.OCCASION_TYPE = {
  WEDDING_DATE: 1,
  CHILD_BIRTHDAY: 2
};
M.OCCASION_DATE.DATA_SOURCE = {
  EMAIL_PREFERENCE_CENTER: 1,
  GENERIC_SAMPLE_KIT: 2,
  GENERIC_SAMPLE_KIT_WEDDING: 3,
  GENERIC_SAMPLE_KIT_SAVETHEDATE: 4,
  GENERIC_SAMPLE_KIT_LETTERPRESS: 5,
  GENERIC_SAMPLE_KIT_HOLIDAYFOIL: 6,
  GENERIC_SAMPLE_KIT_BIRTH_ANNOUNCEMENT: 7,
  LANDING_PAGE: 8,
  CUSTOM_COLOR_SAMPLE: 9
};

M.ORDERS_PAGE_KEEPSAKE_SCALING_FACTOR = 0.7;

M.ORDER_CONFIRM_MAX_IMAGE_WIDTH = 120;
M.ORDER_CONFIRM_FRAMED_IMAGE_SCALING_FACTOR = 0.26;
M.ORDER_CONFIRM_FRAMED_KEEPSAKE_ORDER_LIST_SCALING_FACTOR = 0.17;
M.ORDER_CONFIRM_KEEPSAKE_MAX_IMAGE_WIDTH = 260;
M.ORDER_CONFIRM_UPSELL_MAX_IMAGE_WIDTH = 215;
M.ORDER_CONFIRM_UPSELL_SCALING_FACTOR = 0.48;
M.ORDER_CONFIRM_FRAMED_KEEPSAKE_SCALING_FACTOR = 0.329;
M.ORDER_CONFIRM_MAX_KEEPSAKE_QUANTITY = 10;

// For sizing the signatures on limited edition art PDPs.
// Signature size increases slightly as art print size increases.
// All measurements in inches.
M.PRINT_HEIGHT_TO_SIGNATURE_HEIGHT = {
  '5': 0.4,
  '7': 0.4,
  '8': 0.4,
  '10': 0.4,
  '11': 0.4,
  '14': 0.4,
  '16': 0.5,
  '18': 0.5,
  '20': 0.5,
  '24': 0.5,
  '30': 0.6,
  '40': 0.6,
  '44': 0.6,
  '54': 0.6,
  '60': 0.6
};

// For positioning the signatures on limited edition art PDPs.
// Margins in x, y format, refer to position from the right, bottom of art print
// All measurements in inches.
M.PRINT_SIZE_TO_SIGNATURE_MARGINS = {
  'portrait': {
    '5x7': [0.5, 0.2],
    '8x10': [0.75, 0.35],
    '11x14': [0.75, 0.35],
    '16x20': [1.25, 0.65],
    '18x24': [1.75, 1.15],
    '24x30': [1.875, 1.275],
    '30x40': [2.5, 1.8],
    '40x54': [2.5, 1.8],
    '40x60': [2.5, 1.8],
    '44x60': [2.5, 1.8]
  },
  'landscape': {
    '7x5': [0.5, 0.2],
    '10x8': [0.75, 0.35],
    '14x11': [0.75, 0.35],
    '20x16': [1.25, 0.65],
    '24x18': [1.75, 1.15],
    '30x24': [1.875, 1.275],
    '40x30': [2.5, 1.8],
    '54x40': [2.5, 1.8],
    '60x40': [2.5, 1.8],
    '60x44': [2.5, 1.8]
  },
  'square': {
    '8x8': [0.75, 0.35],
    '11x11': [0.75, 0.35],
    '16x16': [1.25, 0.65],
    '24x24': [2, 1.4],
    '30x30': [2.5, 1.8],
    '44x44': [2.5, 1.8]
  }
};

// A mapping of product size and frame choice to the dimensions of the art print area within each
M.FRAMED_PRODUCT_IMAGE_PREVIEW_SIZES_PDP = {
  'portrait': {
    '5x7':   { 1: [334, 468], 2: [334, 468], 3: [334, 468], 4: [298, 417], 5: [298, 417], 6: [283, 396], 7: [283, 396], 8: [283, 396], 9: [283, 396], 11: [320, 449], 12: [320, 449], 15: [374, 518], 16: [374, 518], 17: [374, 518], 18: [374, 518], 19: [374, 518], 20: [334, 468], 21: [334, 468], 22: [334, 468], 23: [334, 468] },
    '8x10':  { 1: [395, 491], 2: [395, 491], 3: [395, 491], 4: [364, 452], 5: [364, 452], 6: [349, 433], 7: [349, 433], 8: [349, 433], 9: [349, 433], 11: [382, 476], 12: [382, 476], 15: [423, 526], 16: [423, 526], 17: [423, 526], 18: [423, 526], 19: [423, 526], 20: [395, 491], 21: [395, 491], 22: [395, 491], 23: [395, 491] },
    '11x14': { 1: [398, 509], 2: [398, 509], 3: [398, 509], 4: [373, 478], 5: [373, 478], 6: [362, 463], 7: [362, 463], 8: [362, 463], 9: [362, 463], 11: [390, 479], 12: [390, 479], 15: [421, 533], 16: [421, 533], 17: [421, 533], 18: [421, 533], 19: [421, 533], 20: [398, 509], 21: [398, 509], 22: [398, 509], 23: [398, 509] },
    '16x20': { 1: [421, 522], 2: [421, 522], 3: [421, 522], 4: [402, 499], 5: [402, 499], 6: [393, 487], 7: [393, 487], 8: [393, 487], 9: [393, 487], 11: [408, 510], 12: [408, 510], 15: [428, 534], 16: [428, 534], 17: [428, 534], 18: [428, 534], 19: [428, 534], 20: [421, 522], 21: [421, 522], 22: [421, 522], 23: [421, 522] },
    '18x24': { 1: [374, 500], 2: [374, 500], 3: [381, 509], 4: [362, 484], 5: [362, 484], 6: [361, 482], 7: [348, 465], 8: [348, 465], 9: [348, 465], 11: [370, 494], 12: [370, 494], 15: [404, 538], 16: [404, 538], 17: [404, 538], 18: [404, 538], 19: [404, 538], 20: [374, 500], 21: [374, 500], 22: [374, 500], 23: [374, 500] },
    '24x30': { 1: [420, 525], 2: [420, 525], 3: [420, 525], 6: [391, 487], 7: [380, 474], 8: [380, 474], 9: [380, 474], 11: [406, 506], 12: [420, 525], 15: [426, 532], 16: [426, 532], 17: [426, 532], 18: [426, 532], 19: [426, 532], 20: [420, 525], 21: [420, 525], 22: [420, 525], 23: [420, 525] },
    '30x40': { 1: [394, 521], 2: [394, 521], 3: [399, 529], 4: [386, 510], 5: [386, 510], 6: [386, 510], 7: [376, 498], 8: [376, 498], 9: [376, 498], 11: [379, 506], 12: [379, 506], 15: [404, 538], 16: [404, 538], 17: [404, 538], 18: [404, 538], 19: [404, 538], 20: [394, 521], 21: [394, 521], 22: [394, 521], 23: [394, 521] },
    '40x54': { 1: [390, 526], 2: [390, 526], 3: [390, 526], 4: [390, 526], 5: [390, 526], 6: [390, 526], 7: [390, 526], 8: [390, 526], 9: [390, 526], 11: [390, 526], 12: [390, 526], 15: [401, 541], 16: [401, 541], 17: [401, 541], 18: [401, 541], 19: [401, 541], 20: [390, 526], 21: [390, 526], 22: [390, 526], 23: [390, 526] }
  },
  'landscape': {
    '7x5':   { 1: [467, 334], 2: [467, 334], 3: [465, 333], 4: [419, 300], 5: [419, 300], 6: [396, 283], 7: [396, 283], 8: [396, 283], 9: [396, 283], 11: [449, 320], 12: [449, 320], 15: [518, 374], 16: [518, 374], 17: [518, 374], 18: [518, 374], 19: [518, 374], 20: [467, 334], 21: [467, 334], 22: [467, 334], 23: [467, 334] },
    '10x8':  { 1: [491, 395], 2: [491, 395], 3: [490, 395], 4: [450, 363], 5: [450, 363], 6: [433, 349], 7: [433, 349], 8: [433, 349], 9: [433, 349], 11: [476, 382], 12: [476, 382], 15: [526, 423], 16: [526, 423], 17: [526, 423], 18: [526, 423], 19: [526, 423], 20: [491, 395], 21: [491, 395], 22: [491, 395], 23: [491, 395] },
    '14x11': { 1: [506, 396], 2: [506, 396], 3: [510, 399], 4: [479, 374], 5: [479, 374], 6: [462, 362], 7: [462, 362], 8: [462, 362], 9: [462, 362], 11: [479, 390], 12: [479, 390], 15: [533, 421], 16: [533, 421], 17: [533, 421], 18: [533, 421], 19: [533, 421], 20: [506, 396], 21: [506, 396], 22: [506, 396], 23: [506, 396] },
    '20x16': { 1: [522, 421], 2: [522, 421], 3: [521, 420], 4: [500, 404], 5: [500, 404], 6: [487, 393], 7: [487, 393], 8: [487, 393], 9: [487, 393], 11: [510, 408], 12: [510, 408], 15: [534, 428], 16: [534, 428], 17: [534, 428], 18: [534, 428], 19: [534, 428], 20: [522, 421], 21: [522, 421], 22: [522, 421], 23: [522, 421] },
    '24x18': { 1: [500, 374], 2: [500, 374], 3: [509, 382], 4: [483, 362], 5: [483, 362], 6: [483, 362], 7: [465, 348], 8: [465, 348], 9: [465, 348], 11: [494, 370], 12: [494, 370], 15: [538, 404], 16: [538, 404], 17: [538, 404], 18: [538, 404], 19: [538, 404], 20: [500, 374], 21: [500, 374], 22: [500, 374], 23: [500, 374] },
    '30x24': { 1: [525, 420], 2: [525, 420], 3: [525, 420], 6: [487, 391], 7: [474, 380], 8: [474, 380], 9: [474, 380], 11: [506, 406], 12: [525, 420], 15: [532, 426], 16: [532, 426], 17: [532, 426], 18: [532, 426], 19: [532, 426], 20: [525, 420], 21: [525, 420], 22: [525, 420], 23: [525, 420] },
    '40x30': { 1: [529, 399], 2: [529, 399], 3: [522, 394], 4: [508, 384], 5: [508, 384], 6: [511, 386], 7: [498, 376], 8: [498, 376], 9: [498, 376], 11: [506, 379], 12: [506, 379], 15: [538, 404], 16: [538, 404], 17: [538, 404], 18: [538, 404], 19: [538, 404], 20: [529, 399], 21: [529, 399], 22: [529, 399], 23: [529, 399] },
    '54x40': { 1: [526, 390], 2: [526, 390], 3: [526, 390], 4: [526, 390], 5: [526, 390], 6: [526, 390], 7: [526, 390], 8: [526, 390], 9: [526, 390], 11: [526, 390], 12: [526, 390], 15: [541, 401], 16: [541, 401], 17: [541, 401], 18: [541, 401], 19: [541, 401], 20: [526, 390], 21: [526, 390], 22: [526, 390], 23: [526, 390] }
  },
  'square': {
    '8x8':   { 1: [387, 387], 2: [387, 387], 3: [386, 386], 4: [350, 350], 5: [350, 350], 6: [333, 333], 7: [333, 333], 8: [333, 333], 9: [333, 333], 11: [375, 375], 12: [375, 375], 15: [424, 424], 16: [424, 424], 17: [424, 424], 18: [424, 424], 19: [424, 424], 20: [387, 387], 21: [387, 387], 22: [387, 387], 23: [387, 387] },
    '11x11': { 1: [404, 404], 2: [404, 404], 3: [404, 404], 4: [373, 373], 5: [373, 373], 6: [360, 360], 7: [360, 360], 8: [360, 360], 9: [360, 360], 11: [395, 395], 12: [395, 395], 15: [432, 432], 16: [432, 432], 17: [432, 432], 18: [432, 432], 19: [432, 432], 20: [404, 404], 21: [404, 404], 22: [404, 404], 23: [404, 404] },
    '16x16': { 1: [418, 418], 2: [418, 418], 3: [419, 419], 4: [396, 396], 5: [396, 396], 6: [385, 385], 7: [385, 385], 8: [385, 385], 9: [385, 385], 11: [420, 420], 12: [420, 420], 15: [431, 431], 16: [431, 431], 17: [431, 431], 18: [431, 431], 19: [431, 431], 20: [418, 418], 21: [418, 418], 22: [418, 418], 23: [418, 418] },
    '24x24': { 1: [416, 416], 2: [416, 416], 3: [416, 416], 4: [394, 394], 5: [394, 394], 6: [379, 379], 7: [379, 379], 8: [379, 379], 9: [379, 379], 11: [408, 408], 12: [408, 408], 15: [432, 432], 16: [432, 432], 17: [432, 432], 18: [432, 432], 19: [432, 432], 20: [416, 416], 21: [416, 416], 22: [416, 416], 23: [416, 416] },
    '30x30': { 1: [417, 417], 2: [417, 417], 3: [423, 423], 4: [404, 404], 5: [404, 404], 6: [404, 404], 7: [392, 392], 8: [392, 392], 9: [392, 392], 11: [419, 419], 12: [419, 419], 15: [435, 435], 16: [435, 435], 17: [435, 435], 18: [435, 435], 19: [435, 435], 20: [417, 417], 21: [417, 417], 22: [417, 417], 23: [417, 417] },
    '44x44': { 1: [421, 421], 2: [421, 421], 3: [424, 424], 4: [411, 411], 5: [411, 411], 6: [412, 412], 7: [402, 402], 8: [402, 402], 9: [402, 402], 11: [429, 429], 12: [429, 429], 15: [438, 438], 16: [438, 438], 17: [438, 438], 18: [438, 438], 19: [438, 438], 20: [421, 421], 21: [421, 421], 22: [421, 421], 23: [421, 421] }
  }
};

// This is calculated based on M.FRAMED_PRODUCT_IMAGE_PREVIEW_SIZES_PDP
//    , multiplied by a factor of 0.391

// Purchase Flow preview max-width/height = 550px
// PDP preview max-width/height = 215px
// 215/550 ~= 0.391
M.FRAMED_PRODUCT_IMAGE_PREVIEW_SIZES = {
  'portrait': {
    '5x7':   { 1: [130.6, 183.0], 2: [130.6, 183.0], 3: [130.6, 183.0], 4: [116.5, 163.0], 5: [116.5, 163.0], 6: [110.7, 154.8], 7: [110.7, 154.8], 8: [110.7, 154.8], 9: [110.7, 154.8], 11: [125.1, 175.6], 12: [125.1, 175.6], 15: [146.2, 202.5], 16: [146.2, 202.5], 17: [146.2, 202.5], 18: [146.2, 202.5], 19: [146.2, 202.5], 20: [130.6, 183.0], 21:[130.6, 183.0], 22: [130.6, 183.0], 23: [130.6, 183.0] },
    '8x10':  { 1: [154.4, 192.0], 2: [154.4, 192.0], 3: [154.4, 192.0], 4: [142.3, 176.7], 5: [142.3, 176.7], 6: [136.5, 169.3], 7: [136.5, 169.3], 8: [136.5, 169.3], 9: [136.5, 169.3], 11: [149.4, 186.1], 12: [149.4, 186.1], 15: [165.4, 205.7], 16: [165.4, 205.7], 17: [165.4, 205.7], 18: [165.4, 205.7], 19: [165.4, 205.7], 20: [154.4, 192.0], 21:[154.4, 192.0], 22: [154.4, 192.0], 23: [154.4, 192.0] },
    '11x14': { 1: [155.6, 199.0], 2: [155.6, 199.0], 3: [155.6, 199.0], 4: [145.8, 186.9], 5: [145.8, 186.9], 6: [141.5, 181.0], 7: [141.5, 181.0], 8: [141.5, 181.0], 9: [141.5, 181.0], 11: [152.5, 187.3], 12: [152.5, 187.3], 15: [164.6, 208.4], 16: [164.6, 208.4], 17: [164.6, 208.4], 18: [164.6, 208.4], 19: [164.6, 208.4], 20: [155.6, 199.0], 21:[155.6, 199.0], 22: [155.6, 199.0], 23: [155.6, 199.0] },
    '16x20': { 1: [164.6, 204.1], 2: [164.6, 204.1], 3: [164.6, 204.1], 4: [157.2, 195.1], 5: [157.2, 195.1], 6: [153.7, 190.4], 7: [153.7, 190.4], 8: [153.7, 190.4], 9: [153.7, 190.4], 11: [159.5, 199.4], 12: [159.5, 199.4], 15: [167.3, 208.8], 16: [167.3, 208.8], 17: [167.3, 208.8], 18: [167.3, 208.8], 19: [167.3, 208.8], 20: [164.6, 204.1], 21:[164.6, 204.1], 22: [164.6, 204.1], 23: [164.6, 204.1] },
    '18x24': { 1: [146.2, 195.5], 2: [146.2, 195.5], 3: [149.0, 199.0], 4: [141.5, 189.2], 5: [141.5, 189.2], 6: [141.2, 188.5], 7: [136.1, 181.8], 8: [136.1, 181.8], 9: [136.1, 181.8], 11: [144.7, 193.2], 12: [144.7, 193.2], 15: [158.0, 210.4], 16: [158.0, 210.4], 17: [158.0, 210.4], 18: [158.0, 210.4], 19: [158.0, 210.4], 20: [146.2, 195.5], 21:[146.2, 195.5], 22: [146.2, 195.5], 23: [146.2, 195.5] },
    '24x30': { 1: [164.2, 205.3], 2: [164.2, 205.3], 3: [164.2, 205.3], 6: [152.9, 190.4], 7: [148.6, 185.3], 8: [148.6, 185.3], 9: [148.6, 185.3], 11: [158.7, 197.8], 12: [164.2, 205.3], 15: [166.6, 208.0], 16: [166.6, 208.0], 17: [166.6, 208.0], 18: [166.6, 208.0], 19: [166.6, 208.0], 20: [164.2, 205.3], 21:[164.2, 205.3], 22: [164.2, 205.3], 23: [164.2, 205.3] },
    '30x40': { 1: [154.1, 203.7], 2: [154.1, 203.7], 3: [156.0, 206.8], 4: [150.9, 199.4], 5: [150.9, 199.4], 6: [150.9, 199.4], 7: [147.0, 194.7], 8: [147.0, 194.7], 9: [147.0, 194.7], 11: [148.2, 197.8], 12: [148.2, 197.8], 15: [158.0, 210.4], 16: [158.0, 210.4], 17: [158.0, 210.4], 18: [158.0, 210.4], 19: [158.0, 210.4], 20: [154.1, 203.7], 21:[154.1, 203.7], 22: [154.1, 203.7], 23: [154.1, 203.7] },
    '40x54': { 1: [152.5, 205.7], 2: [152.5, 205.7], 3: [152.5, 205.7], 4: [152.5, 205.7], 5: [152.5, 205.7], 6: [152.5, 205.7], 7: [152.5, 205.7], 8: [152.5, 205.7], 9: [152.5, 205.7], 11: [152.5, 205.7], 12: [152.5, 205.7], 15: [156.8, 211.5], 16: [156.8, 211.5], 17: [156.8, 211.5], 18: [156.8, 211.5], 19: [156.8, 211.5], 20: [152.5, 205.7], 21:[152.5, 205.7], 22: [152.5, 205.7], 23: [152.5, 205.7] }
  },
  'landscape': {
    '7x5':   { 1: [182.6, 130.6], 2: [182.6, 130.6], 3: [181.8, 130.2], 4: [163.8, 117.3], 5: [163.8, 117.3], 6: [154.8, 110.7], 7: [154.8, 110.7], 8: [154.8, 110.7], 9: [154.8, 110.7], 11: [175.6, 125.1], 12: [175.6, 125.1], 15: [202.5, 146.2], 16: [202.5, 146.2], 17: [202.5, 146.2], 18: [202.5, 146.2], 19: [202.5, 146.2], 20: [182.6, 130.6], 21: [182.6, 130.6], 22: [182.6, 130.6], 23: [182.6, 130.6] },
    '10x8':  { 1: [192.0, 154.4], 2: [192.0, 154.4], 3: [191.6, 154.4], 4: [176.0, 141.9], 5: [176.0, 141.9], 6: [169.3, 136.5], 7: [169.3, 136.5], 8: [169.3, 136.5], 9: [169.3, 136.5], 11: [186.1, 149.4], 12: [186.1, 149.4], 15: [205.7, 165.4], 16: [205.7, 165.4], 17: [205.7, 165.4], 18: [205.7, 165.4], 19: [205.7, 165.4], 20: [192.0, 154.4], 21: [192.0, 154.4], 22: [192.0, 154.4], 23: [192.0, 154.4] },
    '14x11': { 1: [197.8, 154.8], 2: [197.8, 154.8], 3: [199.4, 156.0], 4: [187.3, 146.2], 5: [187.3, 146.2], 6: [180.6, 141.5], 7: [180.6, 141.5], 8: [180.6, 141.5], 9: [180.6, 141.5], 11: [187.3, 152.5], 12: [187.3, 152.5], 15: [208.4, 164.6], 16: [208.4, 164.6], 17: [208.4, 164.6], 18: [208.4, 164.6], 19: [208.4, 164.6], 20: [197.8, 154.8], 21: [197.8, 154.8], 22: [197.8, 154.8], 23: [197.8, 154.8] },
    '20x16': { 1: [204.1, 164.6], 2: [204.1, 164.6], 3: [203.7, 164.2], 4: [195.5, 158.0], 5: [195.5, 158.0], 6: [190.4, 153.7], 7: [190.4, 153.7], 8: [190.4, 153.7], 9: [190.4, 153.7], 11: [199.4, 159.5], 12: [199.4, 159.5], 15: [208.8, 167.3], 16: [208.8, 167.3], 17: [208.8, 167.3], 18: [208.8, 167.3], 19: [208.8, 167.3], 20: [204.1, 164.6], 21: [204.1, 164.6], 22: [204.1, 164.6], 23: [204.1, 164.6] },
    '24x18': { 1: [195.5, 146.2], 2: [195.5, 146.2], 3: [199.0, 149.4], 4: [188.9, 141.5], 5: [188.9, 141.5], 6: [188.9, 141.5], 7: [181.8, 136.1], 8: [181.8, 136.1], 9: [181.8, 136.1], 11: [193.2, 144.7], 12: [193.2, 144.7], 15: [210.4, 158.0], 16: [210.4, 158.0], 17: [210.4, 158.0], 18: [210.4, 158.0], 19: [210.4, 158.0], 20: [195.5, 146.2], 21: [195.5, 146.2], 22: [195.5, 146.2], 23: [195.5, 146.2] },
    '30x24': { 1: [205.3, 164.2], 2: [205.3, 164.2], 3: [205.3, 164.2], 6: [190.4, 152.9], 7: [185.3, 148.6], 8: [185.3, 148.6], 9: [185.3, 148.6], 11: [197.8, 158.7], 12: [205.3, 164.2], 15: [208.0, 166.6], 16: [208.0, 166.6], 17: [208.0, 166.6], 18: [208.0, 166.6], 19: [208.0, 166.6], 20: [205.3, 164.2], 21: [205.3, 164.2], 22: [205.3, 164.2], 23: [205.3, 164.2] },
    '40x30': { 1: [206.8, 156.0], 2: [206.8, 156.0], 3: [204.1, 154.1], 4: [198.6, 150.1], 5: [198.6, 150.1], 6: [199.8, 150.9], 7: [194.7, 147.0], 8: [194.7, 147.0], 9: [194.7, 147.0], 11: [197.8, 148.2], 12: [197.8, 148.2], 15: [210.4, 158.0], 16: [210.4, 158.0], 17: [210.4, 158.0], 18: [210.4, 158.0], 19: [210.4, 158.0], 20: [206.8, 156.0], 21: [206.8, 156.0], 22: [206.8, 156.0], 23: [206.8, 156.0] },
    '54x40': { 1: [205.7, 152.5], 2: [205.7, 152.5], 3: [205.7, 152.5], 4: [205.7, 152.5], 5: [205.7, 152.5], 6: [205.7, 152.5], 7: [205.7, 152.5], 8: [205.7, 152.5], 9: [205.7, 152.5], 11: [205.7, 152.5], 12: [205.7, 152.5], 15: [211.5, 156.8], 16: [211.5, 156.8], 17: [211.5, 156.8], 18: [211.5, 156.8], 19: [211.5, 156.8], 20: [205.7, 152.5], 21: [205.7, 152.5], 22: [205.7, 152.5], 23: [205.7, 152.5] }
  },
  'square': {
    '8x8':   { 1: [151.3, 151.3], 2: [151.3, 151.3], 3: [150.9, 150.9], 4: [136.8, 136.8], 5: [136.8, 136.8], 6: [130.2, 130.2], 7: [130.2, 130.2], 8: [130.2, 130.2], 9: [130.2, 130.2], 11: [146.6, 146.6], 12: [146.6, 146.6], 15: [165.8, 165.8], 16: [165.8, 165.8], 17: [165.8, 165.8], 18: [165.8, 165.8], 19: [165.8, 165.8], 20: [151.3, 151.3], 21: [151.3, 151.3], 22: [151.3, 151.3], 23: [151.3, 151.3]},
    '11x11': { 1: [158.0, 158.0], 2: [158.0, 158.0], 3: [158.0, 158.0], 4: [145.8, 145.8], 5: [145.8, 145.8], 6: [140.8, 140.8], 7: [140.8, 140.8], 8: [140.8, 140.8], 9: [140.8, 140.8], 11: [154.4, 154.4], 12: [154.4, 154.4], 15: [168.9, 168.9], 16: [168.9, 168.9], 17: [168.9, 168.9], 18: [168.9, 168.9], 19: [168.9, 168.9], 20: [158.0, 158.0], 21: [158.0, 158.0], 22: [158.0, 158.0], 23: [158.0, 158.0]},
    '16x16': { 1: [163.4, 163.4], 2: [163.4, 163.4], 3: [163.8, 163.8], 4: [154.8, 154.8], 5: [154.8, 154.8], 6: [150.5, 150.5], 7: [150.5, 150.5], 8: [150.5, 150.5], 9: [150.5, 150.5], 11: [164.2, 164.2], 12: [164.2, 164.2], 15: [168.5, 168.5], 16: [168.5, 168.5], 17: [168.5, 168.5], 18: [168.5, 168.5], 19: [168.5, 168.5], 20: [163.4, 163.4], 21: [163.4, 163.4], 22: [163.4, 163.4], 23: [163.4, 163.4]},
    '24x24': { 1: [162.7, 162.7], 2: [162.7, 162.7], 3: [162.7, 162.7], 4: [154.1, 154.1], 5: [154.1, 154.1], 6: [148.2, 148.2], 7: [148.2, 148.2], 8: [148.2, 148.2], 9: [148.2, 148.2], 11: [159.5, 159.5], 12: [159.5, 159.5], 15: [168.9, 168.9], 16: [168.9, 168.9], 17: [168.9, 168.9], 18: [168.9, 168.9], 19: [168.9, 168.9], 20: [162.7, 162.7], 21: [162.7, 162.7], 22: [162.7, 162.7], 23: [162.7, 162.7]},
    '30x30': { 1: [163.0, 163.0], 2: [163.0, 163.0], 3: [165.4, 165.4], 4: [158.0, 158.0], 5: [158.0, 158.0], 6: [158.0, 158.0], 7: [153.3, 153.3], 8: [153.3, 153.3], 9: [153.3, 153.3], 11: [163.8, 163.8], 12: [163.8, 163.8], 15: [170.1, 170.1], 16: [170.1, 170.1], 17: [170.1, 170.1], 18: [170.1, 170.1], 19: [170.1, 170.1], 20: [163.0, 163.0], 21: [163.0, 163.0], 22: [163.0, 163.0], 23: [163.0, 163.0]},
    '44x44': { 1: [164.6, 164.6], 2: [164.6, 164.6], 3: [165.8, 165.8], 4: [160.7, 160.7], 5: [160.7, 160.7], 6: [161.1, 161.1], 7: [157.2, 157.2], 8: [157.2, 157.2], 9: [157.2, 157.2], 11: [167.7, 167.7], 12: [167.7, 167.7], 15: [171.3, 171.3], 16: [171.3, 171.3], 17: [171.3, 171.3], 18: [171.3, 171.3], 19: [171.3, 171.3], 20: [164.6, 164.6], 21: [164.6, 164.6], 22: [164.6, 164.6], 23: [164.6, 164.6]}
  }
};

// A mapping of art print frame image size for given orientation & sizes to their dimensions
M.FRAME_IMAGE_SIZES = {
  'portrait': {
    '40x54':  [448, 570],
    '30x40':  [448, 570],
    '24x30':  [476, 570],
    '18x24':  [457, 570],
    '16x20':  [483, 570],
    '11x14':  [468, 570],
    '8x10':  [489, 570],
    '5x7':  [460, 570]
  },
  'landscape': {
    '54x40':  [570, 448],
    '40x30':  [570, 448],
    '30x24':  [570, 476],
    '24x18':  [570, 457],
    '20x16':  [570, 475],
    '14x11':  [570, 473],
    '10x8':  [570, 486],
    '7x5':  [570, 460]
  },
  'square': {
    '44x44':  [470, 470],
    '30x30':  [470, 470],
    '24x24':  [470, 470],
    '16x16':  [470, 470],
    '11x11':  [470, 470],
    '8x8':  [470, 470]
  }
};

// The above dictionary proportionally shrunken to 215px thumbnail sized. Used throughout checkout flow
M.FRAME_IMAGE_PREVIEW_SIZES = {
  'portrait': {
    '40x54':  [169, 215],
    '30x40':  [169, 215],
    '24x30':  [180, 215],
    '18x24':  [172, 215],
    '16x20':  [182, 215],
    '11x14':  [177, 215],
    '8x10':  [184, 215],
    '5x7':  [174, 215]
  },
  'landscape': {
    '54x40':  [215, 169],
    '40x30':  [215, 169],
    '30x24':  [215, 180],
    '24x18':  [215, 172],
    '20x16':  [215, 179],
    '14x11':  [215, 178],
    '10x8':  [215, 183],
    '7x5':  [215, 174]
  },
  'square': {
    '44x44':  [215, 215],
    '30x30':  [215, 215],
    '24x24':  [215, 215],
    '16x16':  [215, 215],
    '11x11':  [215, 215],
    '8x8':  [215, 215]
  }
};

// The above dictionary proportionally shrunken to max dimension 150px. Used on /orders page
M.FRAME_IMAGE_PREVIEW_SIZES_SMALL = {
  'portrait': {
    '40x54': [105, 150],
    '30x40': [105, 150],
    '24x30': [125, 150],
    '18x24': [107, 150],
    '16x20': [113, 150],
    '11x14': [110, 150],
    '8x10': [114, 150],
    '5x7': [108, 150]
  },
  'landscape': {
    '54x40': [150, 105],
    '40x30': [150, 105],
    '30x24': [150, 125],
    '24x18': [150, 107],
    '20x16': [150, 113],
    '14x11': [150, 110],
    '10x8': [150, 114],
    '7x5': [150, 108]
  },
  'square': {
    '44x44':  [150, 150],
    '30x30':  [150, 150],
    '24x24':  [150, 150],
    '16x16':  [150, 150],
    '11x11':  [150, 150],
    '8x8':  [150, 150]
  }
}

// determined by the ratio of width to height of the
// signature asset we ask from designers.
M.SIGNATURE_HEIGHT_RATIO = 0.289;
M.ARTIST_SIGNATURE_WIDTH_TO_HEIGHT_RATIO = 415/120;

M.EXTENSION.PNG = '.png';
M.EXTENSION.GMC = '.gmc';

// js representation of part of a name stored in UserAssetType.asset_type_name
M.DESIGNER_SIGNATURE.STOCK_SIG_PREFIX = 'stock-artist';
M.DESIGNER_SIGNATURE.ARTIST_SIG_PREFIX = 'artist';

M.CHECKOUT.SHIPPING_PROCESS_MESSAGE = {
  PROOFED_ITEMS: "Delivery estimates include proofing, printing, and shipping.",
  NON_PROOFED_ITEMS: "Delivery estimates include processing and shipping.",
  BNPL_ITEMS: "We won't print (or ship) your order until after you've finished personalizing it. " +
    "You'll be able to change your shipping option later, if needed."
};

M.SHIPPING.SHIPPING_OPTION_MESSAGE = {
  DELIVERY_INFO: "Estimated delivery by ",
  BNPL_ITEM: "After you finish personalizing, receive your order in an estimated "
};

M.ALTERNATE_AUTH = {
  FACEBOOK_SERVICE: 0,
  GOOGLE_SERVICE: 1
};

// keep in sync with pattern_tileability.proto in minted_proto repo
M.PATTERN_TILEABILITY = {
  NOT_CHECKED_FOR_TILEABILITY: 0,
  HORIZONTAL_TILEABILITY: 1,
  VERTICAL_TILEABILITY: 2,
  HORIZONTAL_AND_VERTICAL_TILEABILITY: 3,
};


M.FRAME_FORMATS = {
  FULL_BLEED: 'Full bleed',
};

// Purchase Flow preview max-width/height = 550px
// PDP preview max-width/height = 215px
// 215/550 ~= 0.391
M.FULL_BLEED_FRAMED_FORMAT_PRODUCT_IMAGE_PREVIEW_SIZES = {
  'portrait': {
    '5x7':   { 1: [130.6, 183.0], 2: [130.6, 183.0], 3: [130.6, 183.0], 4: [116.5, 163.0], 5: [116.5, 163.0], 6: [110.7, 154.8], 7: [110.7, 154.8], 8: [110.7, 154.8], 9: [110.7, 154.8], 11: [125.1, 175.6], 12: [125.1, 175.6], 15: [138.2, 190.5], 16: [146.2, 202.5], 17: [146.2, 202.5], 18: [146.2, 202.5], 19: [146.2, 202.5], 20: [130.6, 183.0], 21:[130.6, 183.0], 22: [130.6, 183.0], 23: [130.6, 183.0] },
    '8x10':  { 1: [154.4, 192.0], 2: [154.4, 192.0], 3: [154.4, 192.0], 4: [142.3, 176.7], 5: [142.3, 176.7], 6: [136.5, 169.3], 7: [136.5, 169.3], 8: [136.5, 169.3], 9: [136.5, 169.3], 11: [149.4, 186.1], 12: [149.4, 186.1], 15: [145.4, 180.7], 16: [165.4, 205.7], 17: [165.4, 205.7], 18: [165.4, 205.7], 19: [165.4, 205.7], 20: [154.4, 192.0], 21:[154.4, 192.0], 22: [154.4, 192.0], 23: [154.4, 192.0] },
    '11x14': { 1: [155.6, 199.0], 2: [155.6, 199.0], 3: [155.6, 199.0], 4: [145.8, 186.9], 5: [145.8, 186.9], 6: [141.5, 181.0], 7: [141.5, 181.0], 8: [141.5, 181.0], 9: [141.5, 181.0], 11: [152.5, 187.3], 12: [152.5, 187.3], 15: [149.6, 189.4], 16: [164.6, 208.4], 17: [164.6, 208.4], 18: [164.6, 208.4], 19: [164.6, 208.4], 20: [155.6, 199.0], 21:[155.6, 199.0], 22: [155.6, 199.0], 23: [155.6, 199.0] },
    '16x20': { 1: [164.6, 204.1], 2: [164.6, 204.1], 3: [164.6, 204.1], 4: [157.2, 195.1], 5: [157.2, 195.1], 6: [153.7, 190.4], 7: [153.7, 190.4], 8: [153.7, 190.4], 9: [153.7, 190.4], 11: [159.5, 199.4], 12: [159.5, 199.4], 15: [152.3, 190.8], 16: [167.3, 208.8], 17: [167.3, 208.8], 18: [167.3, 208.8], 19: [167.3, 208.8], 20: [164.6, 204.1], 21:[164.6, 204.1], 22: [164.6, 204.1], 23: [164.6, 204.1] },
    '18x24': { 1: [146.2, 195.5], 2: [146.2, 195.5], 3: [149.0, 199.0], 4: [141.5, 189.2], 5: [141.5, 189.2], 6: [141.2, 188.5], 7: [136.1, 181.8], 8: [136.1, 181.8], 9: [136.1, 181.8], 11: [144.7, 193.2], 12: [144.7, 193.2], 15: [149.0, 195.4], 16: [158.0, 210.4], 17: [158.0, 210.4], 18: [158.0, 210.4], 19: [158.0, 210.4], 20: [146.2, 195.5], 21:[146.2, 195.5], 22: [146.2, 195.5], 23: [146.2, 195.5] },
    '24x30': { 1: [164.2, 205.3], 2: [164.2, 205.3], 3: [164.2, 205.3], 6: [152.9, 190.4], 7: [148.6, 185.3], 8: [148.6, 185.3], 9: [148.6, 185.3], 11: [158.7, 197.8], 12: [164.2, 205.3], 15: [151.6, 190.0], 16: [166.6, 208.0], 17: [166.6, 208.0], 18: [166.6, 208.0], 19: [166.6, 208.0], 20: [164.2, 205.3], 21:[164.2, 205.3], 22: [164.2, 205.3], 23: [164.2, 205.3] },
    '30x40': { 1: [154.1, 203.7], 2: [154.1, 203.7], 3: [156.0, 206.8], 4: [150.9, 199.4], 5: [150.9, 199.4], 6: [150.9, 199.4], 7: [147.0, 194.7], 8: [147.0, 194.7], 9: [147.0, 194.7], 11: [148.2, 197.8], 12: [148.2, 197.8], 15: [152.0, 202.4], 16: [158.0, 210.4], 17: [158.0, 210.4], 18: [158.0, 210.4], 19: [158.0, 210.4], 20: [154.1, 203.7], 21:[154.1, 203.7], 22: [154.1, 203.7], 23: [154.1, 203.7] },
    '40x54': { 1: [152.5, 205.7], 2: [152.5, 205.7], 3: [152.5, 205.7], 4: [152.5, 205.7], 5: [152.5, 205.7], 6: [152.5, 205.7], 7: [152.5, 205.7], 8: [152.5, 205.7], 9: [152.5, 205.7], 11: [152.5, 205.7], 12: [152.5, 205.7], 15: [151.8, 203.5], 16: [156.8, 211.5], 17: [156.8, 211.5], 18: [156.8, 211.5], 19: [156.8, 211.5], 20: [152.5, 205.7], 21:[152.5, 205.7], 22: [152.5, 205.7], 23: [152.5, 205.7] }
  },
  'landscape': {
    '7x5':   { 1: [182.6, 130.6], 2: [182.6, 130.6], 3: [181.8, 130.2], 4: [163.8, 117.3], 5: [163.8, 117.3], 6: [154.8, 110.7], 7: [154.8, 110.7], 8: [154.8, 110.7], 9: [154.8, 110.7], 11: [175.6, 125.1], 12: [175.6, 125.1], 15: [192.5, 130.2], 16: [202.5, 146.2], 17: [202.5, 146.2], 18: [202.5, 146.2], 19: [202.5, 146.2], 20: [182.6, 130.6], 21: [182.6, 130.6], 22: [182.6, 130.6], 23: [182.6, 130.6] },
    '10x8':  { 1: [192.0, 154.4], 2: [192.0, 154.4], 3: [191.6, 154.4], 4: [176.0, 141.9], 5: [176.0, 141.9], 6: [169.3, 136.5], 7: [169.3, 136.5], 8: [169.3, 136.5], 9: [169.3, 136.5], 11: [186.1, 149.4], 12: [186.1, 149.4], 15: [185.7, 145.4], 16: [205.7, 165.4], 17: [205.7, 165.4], 18: [205.7, 165.4], 19: [205.7, 165.4], 20: [192.0, 154.4], 21: [192.0, 154.4], 22: [192.0, 154.4], 23: [192.0, 154.4] },
    '14x11': { 1: [197.8, 154.8], 2: [197.8, 154.8], 3: [199.4, 156.0], 4: [187.3, 146.2], 5: [187.3, 146.2], 6: [180.6, 141.5], 7: [180.6, 141.5], 8: [180.6, 141.5], 9: [180.6, 141.5], 11: [187.3, 152.5], 12: [187.3, 152.5], 15: [190.4, 149.6], 16: [208.4, 164.6], 17: [208.4, 164.6], 18: [208.4, 164.6], 19: [208.4, 164.6], 20: [197.8, 154.8], 21: [197.8, 154.8], 22: [197.8, 154.8], 23: [197.8, 154.8] },
    '20x16': { 1: [204.1, 164.6], 2: [204.1, 164.6], 3: [203.7, 164.2], 4: [195.5, 158.0], 5: [195.5, 158.0], 6: [190.4, 153.7], 7: [190.4, 153.7], 8: [190.4, 153.7], 9: [190.4, 153.7], 11: [199.4, 159.5], 12: [199.4, 159.5], 15: [190.8, 149.3], 16: [208.8, 167.3], 17: [208.8, 167.3], 18: [208.8, 167.3], 19: [208.8, 167.3], 20: [204.1, 164.6], 21: [204.1, 164.6], 22: [204.1, 164.6], 23: [204.1, 164.6] },
    '24x18': { 1: [195.5, 146.2], 2: [195.5, 146.2], 3: [199.0, 149.4], 4: [188.9, 141.5], 5: [188.9, 141.5], 6: [188.9, 141.5], 7: [181.8, 136.1], 8: [181.8, 136.1], 9: [181.8, 136.1], 11: [193.2, 144.7], 12: [190.2, 140.7], 15: [198.4, 147.0], 16: [210.4, 158.0], 17: [210.4, 158.0], 18: [210.4, 158.0], 19: [210.4, 158.0], 20: [195.5, 146.2], 21: [195.5, 146.2], 22: [195.5, 146.2], 23: [195.5, 146.2] },
    '30x24': { 1: [205.3, 164.2], 2: [205.3, 164.2], 3: [205.3, 164.2], 6: [190.4, 152.9], 7: [185.3, 148.6], 8: [185.3, 148.6], 9: [185.3, 148.6], 11: [197.8, 158.7], 12: [205.3, 164.2], 15: [192.0, 150.6], 16: [208.0, 166.6], 17: [208.0, 166.6], 18: [208.0, 166.6], 19: [208.0, 166.6], 20: [205.3, 164.2], 21: [205.3, 164.2], 22: [205.3, 164.2], 23: [205.3, 164.2] },
    '40x30': { 1: [206.8, 156.0], 2: [206.8, 156.0], 3: [204.1, 154.1], 4: [198.6, 150.1], 5: [198.6, 150.1], 6: [199.8, 150.9], 7: [194.7, 147.0], 8: [194.7, 147.0], 9: [194.7, 147.0], 11: [197.8, 148.2], 12: [197.8, 148.2], 15: [200.4, 150.0], 16: [210.4, 158.0], 17: [210.4, 158.0], 18: [210.4, 158.0], 19: [210.4, 158.0], 20: [206.8, 156.0], 21: [206.8, 156.0], 22: [206.8, 156.0], 23: [206.8, 156.0] },
    '54x40': { 1: [205.7, 152.5], 2: [205.7, 152.5], 3: [205.7, 152.5], 4: [205.7, 152.5], 5: [205.7, 152.5], 6: [205.7, 152.5], 7: [205.7, 152.5], 8: [205.7, 152.5], 9: [205.7, 152.5], 11: [205.7, 152.5], 12: [205.7, 152.5], 15: [202.5, 150.8], 16: [211.5, 156.8], 17: [211.5, 156.8], 18: [211.5, 156.8], 19: [211.5, 156.8], 20: [205.7, 152.5], 21: [205.7, 152.5], 22: [205.7, 152.5], 23: [205.7, 152.5] }
  },
  'square': {
    '8x8':   { 1: [151.3, 151.3], 2: [151.3, 151.3], 3: [150.9, 150.9], 4: [136.8, 136.8], 5: [136.8, 136.8], 6: [130.2, 130.2], 7: [130.2, 130.2], 8: [130.2, 130.2], 9: [130.2, 130.2], 11: [146.6, 146.6], 12: [146.6, 146.6], 15: [155.8, 155.8], 16: [155.8, 155.8], 17: [155.8, 155.8], 18: [155.8, 155.8], 19: [155.8, 155.8], 20: [151.3, 151.3], 21: [151.3, 151.3], 22: [151.3, 151.3], 23: [151.3, 151.3]},
    '11x11': { 1: [158.0, 158.0], 2: [158.0, 158.0], 3: [158.0, 158.0], 4: [145.8, 145.8], 5: [145.8, 145.8], 6: [140.8, 140.8], 7: [140.8, 140.8], 8: [140.8, 140.8], 9: [140.8, 140.8], 11: [154.4, 154.4], 12: [154.4, 154.4], 15: [158.9, 158.9], 16: [158.9, 158.9], 17: [158.9, 158.9], 18: [158.9, 158.9], 19: [158.9, 158.9], 20: [158.0, 158.0], 21: [158.0, 158.0], 22: [152.0, 152.0], 23: [158.0, 158.0]},
    '16x16': { 1: [163.4, 163.4], 2: [163.4, 163.4], 3: [163.8, 163.8], 4: [154.8, 154.8], 5: [154.8, 154.8], 6: [150.5, 150.5], 7: [150.5, 150.5], 8: [150.5, 150.5], 9: [150.5, 150.5], 11: [164.2, 164.2], 12: [164.2, 164.2], 15: [158.5, 158.5], 16: [158.5, 158.5], 17: [158.5, 158.5], 18: [158.5, 158.5], 19: [158.5, 158.5], 20: [163.4, 163.4], 21: [163.4, 163.4], 22: [152.4, 152.4], 23: [163.4, 163.4]},
    '24x24': { 1: [162.7, 162.7], 2: [162.7, 162.7], 3: [162.7, 162.7], 4: [154.1, 154.1], 5: [154.1, 154.1], 6: [148.2, 148.2], 7: [148.2, 148.2], 8: [148.2, 148.2], 9: [148.2, 148.2], 11: [159.5, 159.5], 12: [159.5, 159.5], 15: [158.9, 158.9], 16: [158.9, 158.9], 17: [158.9, 158.9], 18: [158.9, 158.9], 19: [158.9, 158.9], 20: [162.7, 162.7], 21: [162.7, 162.7], 22: [152.7, 152.7], 23: [162.7, 162.7]},
    '30x30': { 1: [163.0, 163.0], 2: [163.0, 163.0], 3: [165.4, 165.4], 4: [158.0, 158.0], 5: [158.0, 158.0], 6: [158.0, 158.0], 7: [153.3, 153.3], 8: [153.3, 153.3], 9: [153.3, 153.3], 11: [163.8, 163.8], 12: [163.8, 163.8], 15: [160.1, 160.1], 16: [160.1, 160.1], 17: [160.1, 160.1], 18: [160.1, 160.1], 19: [160.1, 160.1], 20: [163.0, 163.0], 21: [163.0, 163.0], 22: [156.0, 156.0], 23: [163.0, 163.0]},
    '44x44': { 1: [164.6, 164.6], 2: [164.6, 164.6], 3: [165.8, 165.8], 4: [160.7, 160.7], 5: [160.7, 160.7], 6: [161.1, 161.1], 7: [157.2, 157.2], 8: [157.2, 157.2], 9: [157.2, 157.2], 11: [167.7, 167.7], 12: [167.7, 167.7], 15: [161.3, 161.3], 16: [161.3, 161.3], 17: [161.3, 161.3], 18: [161.3, 161.3], 19: [161.3, 161.3], 20: [164.6, 164.6], 21: [164.6, 164.6], 22: [156.6, 156.6], 23: [164.6, 164.6]}
  }
};

M.FULL_BLEED_FRAMED_FORMAT_PRODUCT_IMAGE_PREVIEW_SIZES_CART = {
  'portrait': {
    '5x7':   { 1: [130.6, 183.0], 2: [130.6, 183.0], 3: [130.6, 183.0], 4: [116.5, 163.0], 5: [116.5, 163.0], 6: [110.7, 154.8], 7: [110.7, 154.8], 8: [110.7, 154.8], 9: [110.7, 154.8], 11: [125.1, 175.6], 12: [125.1, 175.6], 15: [138.2, 190.5], 16: [146.2, 202.5], 17: [146.2, 202.5], 18: [146.2, 202.5], 19: [146.2, 202.5], 20: [130.6, 183.0], 21:[130.6, 183.0], 22: [130.6, 183.0], 23: [130.6, 183.0] },
    '8x10':  { 1: [154.4, 192.0], 2: [154.4, 192.0], 3: [154.4, 192.0], 4: [142.3, 176.7], 5: [142.3, 176.7], 6: [136.5, 169.3], 7: [136.5, 169.3], 8: [136.5, 169.3], 9: [136.5, 169.3], 11: [149.4, 186.1], 12: [149.4, 186.1], 15: [155.4, 195.7], 16: [165.4, 205.7], 17: [165.4, 205.7], 18: [165.4, 205.7], 19: [165.4, 205.7], 20: [154.4, 192.0], 21:[154.4, 192.0], 22: [154.4, 192.0], 23: [154.4, 192.0] },
    '11x14': { 1: [155.6, 199.0], 2: [155.6, 199.0], 3: [155.6, 199.0], 4: [145.8, 186.9], 5: [145.8, 186.9], 6: [141.5, 181.0], 7: [141.5, 181.0], 8: [141.5, 181.0], 9: [141.5, 181.0], 11: [152.5, 187.3], 12: [152.5, 187.3], 15: [155.6, 199.4], 16: [164.6, 208.4], 17: [164.6, 208.4], 18: [164.6, 208.4], 19: [164.6, 208.4], 20: [155.6, 199.0], 21:[155.6, 199.0], 22: [155.6, 199.0], 23: [155.6, 199.0] },
    '16x20': { 1: [164.6, 204.1], 2: [164.6, 204.1], 3: [164.6, 204.1], 4: [157.2, 195.1], 5: [157.2, 195.1], 6: [153.7, 190.4], 7: [153.7, 190.4], 8: [153.7, 190.4], 9: [153.7, 190.4], 11: [159.5, 199.4], 12: [159.5, 199.4], 15: [157.3, 199.8], 16: [167.3, 208.8], 17: [167.3, 208.8], 18: [167.3, 208.8], 19: [167.3, 208.8], 20: [164.6, 204.1], 21:[164.6, 204.1], 22: [164.6, 204.1], 23: [164.6, 204.1] },
    '18x24': { 1: [146.2, 195.5], 2: [146.2, 195.5], 3: [149.0, 199.0], 4: [141.5, 189.2], 5: [141.5, 189.2], 6: [141.2, 188.5], 7: [136.1, 181.8], 8: [136.1, 181.8], 9: [136.1, 181.8], 11: [144.7, 193.2], 12: [144.7, 193.2], 15: [155.0, 205.4], 16: [158.0, 210.4], 17: [158.0, 210.4], 18: [158.0, 210.4], 19: [158.0, 210.4], 20: [146.2, 195.5], 21:[146.2, 195.5], 22: [146.2, 195.5], 23: [146.2, 195.5] },
    '24x30': { 1: [164.2, 205.3], 2: [164.2, 205.3], 3: [164.2, 205.3], 6: [152.9, 190.4], 7: [148.6, 185.3], 8: [148.6, 185.3], 9: [148.6, 185.3], 11: [158.7, 197.8], 12: [164.2, 205.3], 15: [161.6, 200.0], 16: [166.6, 208.0], 17: [166.6, 208.0], 18: [166.6, 208.0], 19: [166.6, 208.0], 20: [164.2, 205.3], 21:[164.2, 205.3], 22: [164.2, 205.3], 23: [164.2, 205.3] },
    '30x40': { 1: [154.1, 203.7], 2: [154.1, 203.7], 3: [156.0, 206.8], 4: [150.9, 199.4], 5: [150.9, 199.4], 6: [150.9, 199.4], 7: [147.0, 194.7], 8: [147.0, 194.7], 9: [147.0, 194.7], 11: [148.2, 197.8], 12: [148.2, 197.8], 15: [147.0, 202.4], 16: [158.0, 210.4], 17: [158.0, 210.4], 18: [158.0, 210.4], 19: [158.0, 210.4], 20: [154.1, 203.7], 21:[154.1, 203.7], 22: [154.1, 203.7], 23: [154.1, 203.7] },
    '40x54': { 1: [152.5, 205.7], 2: [152.5, 205.7], 3: [152.5, 205.7], 4: [152.5, 205.7], 5: [152.5, 205.7], 6: [152.5, 205.7], 7: [152.5, 205.7], 8: [152.5, 205.7], 9: [152.5, 205.7], 11: [152.5, 205.7], 12: [152.5, 205.7], 15: [148.8, 203.5], 16: [156.8, 211.5], 17: [156.8, 211.5], 18: [156.8, 211.5], 19: [156.8, 211.5], 20: [152.5, 205.7], 21:[152.5, 205.7], 22: [152.5, 205.7], 23: [152.5, 205.7] }
  },
  'landscape': {
    '7x5':   { 1: [182.6, 130.6], 2: [182.6, 130.6], 3: [181.8, 130.2], 4: [163.8, 117.3], 5: [163.8, 117.3], 6: [154.8, 110.7], 7: [154.8, 110.7], 8: [154.8, 110.7], 9: [154.8, 110.7], 11: [175.6, 125.1], 12: [175.6, 125.1], 15: [202.5, 140.2], 16: [202.5, 146.2], 17: [202.5, 146.2], 18: [202.5, 146.2], 19: [202.5, 146.2], 20: [182.6, 130.6], 21: [182.6, 130.6], 22: [182.6, 130.6], 23: [182.6, 130.6] },
    '10x8':  { 1: [192.0, 154.4], 2: [192.0, 154.4], 3: [191.6, 154.4], 4: [176.0, 141.9], 5: [176.0, 141.9], 6: [169.3, 136.5], 7: [169.3, 136.5], 8: [169.3, 136.5], 9: [169.3, 136.5], 11: [186.1, 149.4], 12: [186.1, 149.4], 15: [200.7, 155.4], 16: [205.7, 165.4], 17: [205.7, 165.4], 18: [205.7, 165.4], 19: [205.7, 165.4], 20: [192.0, 154.4], 21: [192.0, 154.4], 22: [192.0, 154.4], 23: [192.0, 154.4] },
    '14x11': { 1: [197.8, 154.8], 2: [197.8, 154.8], 3: [199.4, 156.0], 4: [187.3, 146.2], 5: [187.3, 146.2], 6: [180.6, 141.5], 7: [180.6, 141.5], 8: [180.6, 141.5], 9: [180.6, 141.5], 11: [187.3, 152.5], 12: [187.3, 152.5], 15: [200.4, 159.6], 16: [208.4, 164.6], 17: [208.4, 164.6], 18: [208.4, 164.6], 19: [208.4, 164.6], 20: [197.8, 154.8], 21: [197.8, 154.8], 22: [197.8, 154.8], 23: [197.8, 154.8] },
    '20x16': { 1: [204.1, 164.6], 2: [204.1, 164.6], 3: [203.7, 164.2], 4: [195.5, 158.0], 5: [195.5, 158.0], 6: [190.4, 153.7], 7: [190.4, 153.7], 8: [190.4, 153.7], 9: [190.4, 153.7], 11: [199.4, 159.5], 12: [199.4, 159.5], 15: [200.8, 159.3], 16: [208.8, 167.3], 17: [208.8, 167.3], 18: [208.8, 167.3], 19: [208.8, 167.3], 20: [204.1, 164.6], 21: [204.1, 164.6], 22: [204.1, 164.6], 23: [204.1, 164.6] },
    '24x18': { 1: [195.5, 146.2], 2: [195.5, 146.2], 3: [199.0, 149.4], 4: [188.9, 141.5], 5: [188.9, 141.5], 6: [188.9, 141.5], 7: [181.8, 136.1], 8: [181.8, 136.1], 9: [181.8, 136.1], 11: [193.2, 144.7], 12: [190.2, 140.7], 15: [206.4, 150.0], 16: [210.4, 158.0], 17: [210.4, 158.0], 18: [210.4, 158.0], 19: [210.4, 158.0], 20: [195.5, 146.2], 21: [195.5, 146.2], 22: [195.5, 146.2], 23: [195.5, 146.2] },
    '30x24': { 1: [205.3, 164.2], 2: [205.3, 164.2], 3: [205.3, 164.2], 6: [190.4, 152.9], 7: [185.3, 148.6], 8: [185.3, 148.6], 9: [185.3, 148.6], 11: [197.8, 158.7], 12: [205.3, 164.2], 15: [193.0, 153.6], 16: [208.0, 166.6], 17: [208.0, 166.6], 18: [208.0, 166.6], 19: [208.0, 166.6], 20: [205.3, 164.2], 21: [205.3, 164.2], 22: [205.3, 164.2], 23: [205.3, 164.2] },
    '40x30': { 1: [206.8, 156.0], 2: [206.8, 156.0], 3: [204.1, 154.1], 4: [198.6, 150.1], 5: [198.6, 150.1], 6: [199.8, 150.9], 7: [194.7, 147.0], 8: [194.7, 147.0], 9: [194.7, 147.0], 11: [197.8, 148.2], 12: [197.8, 148.2], 15: [200.4, 150.0], 16: [210.4, 158.0], 17: [210.4, 158.0], 18: [210.4, 158.0], 19: [210.4, 158.0], 20: [206.8, 156.0], 21: [206.8, 156.0], 22: [206.8, 156.0], 23: [206.8, 156.0] },
    '54x40': { 1: [205.7, 152.5], 2: [205.7, 152.5], 3: [205.7, 152.5], 4: [205.7, 152.5], 5: [205.7, 152.5], 6: [205.7, 152.5], 7: [205.7, 152.5], 8: [205.7, 152.5], 9: [205.7, 152.5], 11: [205.7, 152.5], 12: [205.7, 152.5], 15: [202.5, 150.8], 16: [211.5, 156.8], 17: [211.5, 156.8], 18: [211.5, 156.8], 19: [211.5, 156.8], 20: [205.7, 152.5], 21: [205.7, 152.5], 22: [205.7, 152.5], 23: [205.7, 152.5] }
  },
  'square': {
    '8x8':   { 1: [171.3, 171.3], 2: [171.3, 171.3], 3: [175.9, 175.9], 4: [136.8, 136.8], 5: [136.8, 136.8], 6: [150.2, 150.2], 7: [150.2, 150.2], 8: [150.2, 150.2], 9: [150.2, 150.2], 11: [169.6, 169.6], 12: [170.6, 170.6], 15: [195.8, 195.8], 16: [195.8, 195.8], 17: [195.8, 195.8], 18: [195.8, 195.8], 19: [195.8, 195.8], 20: [176.3, 176.3], 21: [181.3, 181.3], 22: [181.3, 181.3], 23: [181.3, 181.3]},
    '11x11': { 1: [178.0, 178.0], 2: [178.0, 178.0], 3: [183.0, 183.0], 4: [145.8, 145.8], 5: [145.8, 145.8], 6: [160.8, 160.8], 7: [160.8, 160.8], 8: [160.8, 160.8], 9: [160.8, 160.8], 11: [184.4, 184.4], 12: [180.4, 180.4], 15: [198.9, 198.9], 16: [198.9, 198.9], 17: [198.9, 198.9], 18: [198.9, 198.9], 19: [198.9, 198.9], 20: [183.0, 183.0], 21: [188.0, 188.0], 22: [188.0, 188.0], 23: [188.0, 188.0]},
    '16x16': { 1: [183.4, 183.4], 2: [183.4, 183.4], 3: [188.8, 188.8], 4: [154.8, 154.8], 5: [154.8, 154.8], 6: [170.5, 170.5], 7: [170.5, 170.5], 8: [170.5, 170.5], 9: [170.5, 170.5], 11: [184.2, 184.2], 12: [188.2, 188.2], 15: [198.5, 198.5], 16: [198.5, 198.5], 17: [198.5, 198.5], 18: [198.5, 198.5], 19: [198.5, 198.5], 20: [188.4, 188.4], 21: [193.4, 193.4], 22: [193.4, 183.4], 23: [193.4, 193.4]},
    '24x24': { 1: [182.7, 182.7], 2: [182.7, 182.7], 3: [187.7, 187.7], 4: [154.1, 154.1], 5: [154.1, 154.1], 6: [175.2, 175.2], 7: [173.2, 173.2], 8: [173.2, 173.2], 9: [173.2, 173.2], 11: [183.5, 183.5], 12: [188.5, 188.5], 15: [198.9, 198.9], 16: [198.9, 198.9], 17: [198.9, 198.9], 18: [198.9, 198.9], 19: [198.9, 198.9], 20: [187.7, 187.7], 21: [200.7, 200.7], 22: [202.7, 202.7], 23: [202.7, 202.7]},
    '30x30': { 1: [183.0, 183.0], 2: [183.0, 183.0], 3: [190.4, 190.4], 4: [158.0, 158.0], 5: [158.0, 158.0], 6: [178.0, 178.0], 7: [173.3, 173.3], 8: [173.3, 173.3], 9: [173.3, 173.3], 11: [187.8, 187.8], 12: [189.8, 189.8], 15: [200.1, 200.1], 16: [200.1, 200.1], 17: [200.1, 200.1], 18: [200.1, 200.1], 19: [200.1, 200.1], 20: [188.0, 188.0], 21: [200.0, 200.0], 22: [203.0, 203.0], 23: [203.0, 203.0]},
    '44x44': { 1: [184.6, 184.6], 2: [184.6, 184.6], 3: [190.8, 190.8], 4: [160.7, 160.7], 5: [160.7, 160.7], 6: [181.1, 181.1], 7: [177.2, 177.2], 8: [177.2, 177.2], 9: [177.2, 177.2], 11: [189.7, 189.7], 12: [193.7, 193.7], 15: [201.3, 201.3], 16: [201.3, 201.3], 17: [201.3, 201.3], 18: [201.3, 201.3], 19: [201.3, 201.3], 20: [189.6, 189.6], 21: [200.6, 200.6], 22: [204.6, 204.6], 23: [204.6, 204.6]}
  }
};

/**
 * ART_FRAMES_IMAGE_SIZE_DATA contains information about the Images, each Size contains aspectRatio & ImagePosition.
 * Aspect Ratio value is calculated from the original Frame Image aspectRatio =  Width / Height.
 * Image Position is the value in percentage of the Top-Left-Inner Corner Frame which is used to
 * correctly position the Frame Art Custom Image inside the frame
 * Note: All frames in one size have the same aspectRatio & Top-Left-Inner Corner, we only need one value per Size.
 */
M.ART_FRAMES_IMAGE_SIZE_DATA = {
  // Portrait Sizes
  '5x7': {
    aspectRatio: 0.807677927927928,
    ImagePosition: [0.205238095238095, 0.165769230769231],
  },
  '8x10': {
    aspectRatio: 0.852272727272727,
    ImagePosition: [0.153809523809524, 0.131087662337662],
  },
  '11x14': {
    aspectRatio: 0.830367734282325,
    ImagePosition: [0.124761904761905, 0.10359826018189],
  },
  '16x20': {
    aspectRatio: 0.833002776675922,
    ImagePosition: [0.098095238095238, 0.081713605712019],
  },
  '18x24': {
    aspectRatio: 0.80091533180778,
    ImagePosition: [0.128571428571429, 0.102974828375286],
  },
  '24x30': {
    aspectRatio: 0.835654596100279,
    ImagePosition: [0.109047619047619, 0.091126144050935],
  },
  '30x40': {
    aspectRatio: 0.786222388618495,
    ImagePosition: [0.09047619047619, 0.071134406589292],
  },
  '40x54': {
    aspectRatio: 0.785222388618495,
    ImagePosition: [0.083290476190476, 0.052002658180457],
  },
  '44x60': {
    aspectRatio: 0.733240223463687,
    ImagePosition: [0.069047619047619, 0.069483240223464],
  },
  '48x70': {
    aspectRatio: 0.721897559298728,
    ImagePosition: [0.067142857142857, 0.043657614300447],
  },
  // Square Sizes
  '8x8': {
    aspectRatio: 1,
    ImagePosition: [0.153333333333333, 0.153333333333333],
  },
  '11x11': {
    aspectRatio: 1,
    ImagePosition: [0.12952380952381, 0.12952380952381],
  },
  '16x16': {
    aspectRatio: 1,
    ImagePosition: [0.09952380952381,0.09952380952381],
  },
  '24x24': {
    aspectRatio: 1,
    ImagePosition: [0.106666666666667, 0.106666666666667],
  },
  '30x30': {
    aspectRatio: 1,
    ImagePosition: [0.092380952380952, 0.092380952380952],
  },
  '44x44': {
    aspectRatio: 1,
    ImagePosition: [0.082857142857143, 0.082857142857143],
  },
  // Landscape Sizes
  '7x5': {
    aspectRatio: 1.238095238095238,
    ImagePosition: [0.163846153846154, 0.202857142857143],
  },
  '10x8': {
    aspectRatio: 1.173333333333333,
    ImagePosition: [0.12987012987013, 0.156666666666667],
  },
  '14x11': {
    aspectRatio: 1.204285714285714,
    ImagePosition: [0.106761565836299, 0.128571428571429],
  },
  '20x16': {
    aspectRatio: 1.20047619047619,
    ImagePosition: [0.083696945656486, 0.10047619047619],
  },
  '24x18': {
    aspectRatio: 1.248571428571429,
    ImagePosition: [0.102593440122044, 0.128095238095238],
  },
  '30x24': {
    aspectRatio: 1.196666666666667,
    ImagePosition: [0.089534421010744, 0.107142857142857],
  },
  '40x30': {
    aspectRatio: 1.271904761904762,
    ImagePosition: [0.072257581430176, 0.091904761904762],
  },
  '54x40': {
    aspectRatio: 1.271904761904762,
    ImagePosition: [0.054902658180457, 0.078666666666667],
  },
  '60x44': {
    aspectRatio: 1.363809523809524,
    ImagePosition: [0.069134078212291, 0.069047619047619],
  },
  '70x48': {
    aspectRatio: 1.385238095238095,
    ImagePosition: [0.043657614300447, 0.066666666666667],
  },
};
/**
 *  4 Pixels
 *  (FRAMED_ART_CUSTOM_IMAGE_BLEED) to allow the Framed Art Custom Image to be 2 Pixels below the
 *  Frame to cover some cases where Full Bleed Framed Art Custom Images have some unwanted white borders
 * @type {number}
 */
M.FRAMED_ART_CUSTOM_IMAGE_BLEED = 4;
M.FRAMED_ART_PREVIEW_SIZE = 215;

return {
  'CLOUDINARY_URL': CLOUDINARY_URL,
  'RGB_HEX_STRING_LENGTH': RGB_HEX_STRING_LENGTH,
  'EnvelopeColorOption': EnvelopeColorOption,
  'EnvelopeColorOptionNameToId': EnvelopeColorOptionNameToId,
  'FreeWhiteEnvelopeColorIds': FreeWhiteEnvelopeColorOptionIds,
  'privacyAssuranceMessage': privacyAssuranceMessage,
  'privacyAssuranceMessageHeader': privacyAssuranceMessageHeader,
  'privacyPolicyURL': privacyPolicyURL
};

});
